"use strict";

import {
  Badge,
  Box,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  InputBase,
  InputLabel,
  MenuItem,
  Rating,
  Select,
  Skeleton,
  Switch,
} from "@mui/material";
import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useContext,
  useMemo,
} from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CheckIcon from "@mui/icons-material/Check";
import DownloadIcon from "@mui/icons-material/Download";
import VideoLibraryOutlinedIcon from "@mui/icons-material/VideoLibraryOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import MovieOutlinedIcon from "@mui/icons-material/MovieOutlined";
import SubtitlesOutlinedIcon from "@mui/icons-material/SubtitlesOutlined";
import classes from "../../Assets/Styles/VoiceQAScreen.module.css";
// Versions and Downloads panels, shared with the QA page.
import qaClasses from "../../Assets/Styles/QAScreen.module.css";
import pageClasses from "../../Assets/Styles/PerformanceDirectionVersions.module.css";
import NonverbalSoundsSection, {
  WorkSectionSwitch,
} from "../../features/nonverbal/NonverbalSoundsSection.js";
import useNonverbalRegions from "../../features/nonverbal/useNonverbalRegions.js";
import { dubStatus } from "../../features/nonverbal/nonverbal.js";
import {
  convertToDate,
  formatInputs,
  parseTimestampAsTotalSeconds,
} from "../../utils/generalFunctions";
import {
  buildPreviewClips,
  ensureProjectFinalLanguageTranslations,
  findTranslationByLanguageCode,
  getDialoguePageEndTime,
  getDefaultVoiceIdForEmotion,
  getGeneratedAudioOptionValue,
  getLineCharacter,
  getPreviewClipsSignature,
  getRecommendedSpeedOption as getProjectWorkRecommendedSpeedOption,
  getSelectedGeneratedAudioValue,
  getSpeakerDisplayName,
  getTranslationDurationMessage,
  isTranslatedAudioOverlapping,
  pickMusicEffectsStemReferences,
} from "../../features/projectWork";

import Loader from "../../Components/Loader";
import axios from "axios";
import { Store } from "../../Store";
import {
  CREATE_NEW_AUDIO,
  GENERATE_SOUND_EFFECT,
  UPDATE_ONE_SPEECH,
  GET_CHARACTERS_FOR_PROJECT,
  GET_SPEECH_FOR_PROJECT_BY_PAGE,
  CREATE_MULTIPLE_AUDIO,
  GET_SPEECH_POSITION_AROUND_TIME,
  SET_DIALOGUE_APPROVAL_STATUS,
  DELETE_SPEECH_FOR_PROJECT,
  ADD_SPEECH_FOR_PROJECT,
  MERGING_FULL_API,
  ADJUST_AUDIO_SPEED,
  ADJUST_AUDIO_SPEED_AUTO,
  SEARCH_SPEECH_FOR_PROJECT,
  GET_ALL_QUALITYASSURANCE_VERSIONS,
  GET_SRT,
  SRT,
} from "../../ApiEndpoints";
import { ToastContainer, toast } from "react-toastify";
import QASubmitBar from "../../features/qaReview/QASubmitBar";
import { postWithQATracking } from "../../features/qaReview/api";
import { useMediaQuery } from "@mui/material";
import PerformanceVideoPlayer from "../../Components/Players/PerformanceVideoPlayer";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useParams, useSearchParams } from "react-router-dom";

import { companyName, secondaryColor } from "../../utils/constants";
import { backgroundWellSx } from "../../theme";
import MediaDownloadMenu from "../../Components/MediaDownloadMenu";
import { buildMediaDownloadItems } from "../../utils/versionMedia";
import CharacterVoicePanel from "../../Components/VoiceCreation/CharacterVoicePanel";
import TaskButton from "../../Components/Buttons/TaskButton";
import {
  DialogueRowActionDialog,
  DialogueRowActions,
} from "../../Components/DialogueRowActions/DialogueRowActions";
import rowActionClasses from "../../Components/DialogueRowActions/DialogueRowActions.module.css";

import {
  DEFAULT_VOICE_ENGINE,
  LEGACY_AUDIO_ENGINE_LABEL,
  SOUND_EFFECT_VOICE_ENGINE,
  VOICE_ENGINE_OPTIONS,
  getSupportedVoiceEngine,
  isLegacyVoiceEngine,
  isSupportedVoiceEngine,
} from "../../Data/voiceEngines";

import ClipLoader from "react-spinners/ClipLoader";
import ClipAudioPlayer from "../../Components/Players/ClipAudioPlayer";
import NativeClipAudioPlayer from "../../Components/Players/NativeClipAudioPlayer";
import styled from "styled-components";
import { styled as muiStyled } from "@mui/material/styles";
import InputMask from "react-input-mask";
import debounce from "lodash.debounce";

import { useExperimentalFeature } from "../../utils/featureAccess";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import VolumeSelector from "../../Components/AudioTools/VolumeSelector";

import {
  DEFAULT_DIALOGUE_SEARCH_FILTERS,
  hasAnyDialogueSearchFilter,
  lineTypeSearchParams,
} from "../../Components/DialogueSearchFilter/DialogueSearchFilter";
import DialogueFilterBar, {
  DIALOGUE_ATTENTION_OPTIONS,
} from "../../Components/DialogueSearchFilter/DialogueFilterBar";
import DialogueAttentionProgress from "../../Components/DialogueSearchFilter/DialogueAttentionProgress";
import { injectToken } from "../../utils/injectToken";
import {
  hydrateDialoguePlaybackUrls,
  readAudioClientResponse,
} from "../../utils/audioMedia";
import ExportLayoutSelect from "../../features/exportLayout/ExportLayoutSelect";
import ExportOptions from "../../features/exportLayout/ExportOptions";
import ExportVideoSourceSelect from "../../features/exportLayout/ExportVideoSourceSelect";
import DownloadOnlyNotice from "../../features/exportLayout/DownloadOnlyNotice";
import {
  audioLayoutLabel,
  DEFAULT_OUTPUT_AUDIO_LAYOUT,
  DEFAULT_VIDEO_SOURCE,
  isPlayableVersion,
  latestVersion,
  PLAYBACK,
  versionPlayback,
  videoSourceLabel,
} from "../../features/exportLayout/audioLayout";
import { useDialoguePlaybackRefresh } from "../../hooks/useDialoguePlaybackRefresh";
import { useProjectMediaPlayback } from "../../hooks/useProjectMediaPlayback";
import { usePagePreviewTimeline } from "../../hooks/usePagePreviewTimeline";

// Compact iOS-style switch (pill track, inset thumb, no ripple) sized to fit
// the 24px dialogue row header line. Uses MUI's styled so these rules share
// MUI's style engine and reliably override the Switch defaults.
const RowFlagSwitch = muiStyled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(() => ({
  width: 32,
  height: 18,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "200ms",
    "&.Mui-checked": {
      transform: "translateX(14px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "var(--color-link-text)",
        opacity: 1,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      outline: "2px solid var(--color-link-text)",
      outlineOffset: 2,
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.5,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 14,
    height: 14,
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.25)",
  },
  "& .MuiSwitch-track": {
    borderRadius: 9,
    backgroundColor: "#c4c7cc",
    opacity: 1,
    transition: "background-color 200ms",
  },
}));

const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {},
  "& .MuiInputBase-input": {
    width: "0px",
    borderRadius: "var(--radius-md)",
    position: "relative",
    backgroundColor: "none",
    border: "none",
    fontSize: "var(--font-size-normal)",
    padding: "6px 20px 6px 12px",
    color: "inherit",
  },
}));

const BootstrapInputForAvalialbe = styled(InputBase)(({ theme }) => ({
  "& .MuiInputBase-input": {
    color: "inherit",
    width: "100%",
    position: "relative",
    backgroundColor: "none",
    border: "none",
    fontSize: "var(--font-size-normal)",
  },
}));

// Matches the player's fixed video height (.AudioOutPutVideoHorizontal).
const VIDEO_HEIGHT_PX = 380;
const DEFAULT_VIDEO_ASPECT_RATIO = 16 / 9;

// A prefetched next page older than this is loaded again, so Next doesn't
// show lines someone else has changed since.
const PREFETCHED_PAGE_MAX_AGE_MS = 60_000;

// Varied line widths so placeholder rows read like real dialogue text.
const SKELETON_LINE_WIDTHS = [
  ["92%", "78%", "55%"],
  ["85%", "64%"],
  ["96%", "88%", "71%"],
  ["74%", "58%"],
  ["90%", "82%", "40%"],
];

// Skeleton rows shown in place of the dialogues while a page loads.
const DialogueTableSkeletonRows = ({ rowCount }) =>
  Array.from({ length: rowCount }, (_, rowIndex) => {
    const lines = SKELETON_LINE_WIDTHS[rowIndex % SKELETON_LINE_WIDTHS.length];
    const translationLines =
      SKELETON_LINE_WIDTHS[(rowIndex + 2) % SKELETON_LINE_WIDTHS.length];

    return (
      <tr key={rowIndex} className={classes["AudioWorkTableRow"]}>
        <td
          className={`${classes["AudioWorkMetaColumn"]} ${classes["AudioWorkTableColumnCharacter"]}`}
        >
          <Grid container direction="column" gap={1.5} alignItems="center">
            <Skeleton
              variant="rounded"
              width="80%"
              height={25}
              sx={{ bgcolor: "rgba(255, 255, 255, 0.2)" }}
            />
            <Skeleton
              variant="text"
              width="60%"
              sx={{ bgcolor: "rgba(255, 255, 255, 0.2)" }}
            />
          </Grid>
        </td>
        <td
          className={`${classes["AudioWorkDataColumn"]} ${classes["AudioWorkTableColumnOriginal"]}`}
        >
          {lines.map((width, lineIndex) => (
            <Skeleton key={lineIndex} variant="text" width={width} />
          ))}
          <Skeleton variant="rounded" height={32} sx={{ mt: 1.5 }} />
        </td>
        <td
          className={`${classes["AudioWorkDataColumn"]} ${classes["AudioWorkTableColumnTranslation"]}`}
        >
          {translationLines.map((width, lineIndex) => (
            <Skeleton key={lineIndex} variant="text" width={width} />
          ))}
        </td>
        <td
          className={`${classes["AudioWorkDataColumn"]} ${classes["AudioWorkTableColumnNewAudio"]}`}
        >
          <Grid container gap={1}>
            <Skeleton variant="rounded" width={90} height={28} />
            <Skeleton variant="rounded" width={70} height={28} />
          </Grid>
          <Skeleton variant="rounded" height={32} sx={{ mt: 1.5 }} />
        </td>
        <td className={classes["AudioWorkDataColumn"]}>
          <Skeleton variant="text" width={80} />
          <Skeleton variant="text" width={80} />
        </td>
        <td className={classes["AudioWorkDataColumn"]}>
          <Skeleton variant="rounded" height={48} />
          <Skeleton variant="text" width={110} sx={{ mt: 1 }} />
        </td>
      </tr>
    );
  });

const VideoPerformanceDirectionVersions = () => {
  const params = useParams();
  const { language: languageCode } = params;
  const [searchParams, setSearchParams] = useSearchParams();
  const screenIsOver1200px = useMediaQuery("(min-width: 1200px)");
  const translatedAudioRefs = useRef([]);
  const originalAudioRefs = useRef([]);

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { projectFile, userInfo } = state;

  // Saves that count as QA review work carry the reviewer's tracking headers.
  const qaPost = useCallback(
    (url, data, config) =>
      postWithQATracking(url, data, config, {
        projectId: projectFile?.id,
        language: languageCode,
      }),
    [projectFile?.id, languageCode]
  );

  const videoReference =
    projectFile?.videoUrl || projectFile?.fileUrl || projectFile?.video || "";
  const { playbackUrl: originalVideoUrl } = useProjectMediaPlayback({
    reference: videoReference,
    projectId: projectFile?.id,
  });
  const [dubbedVideoReference, setDubbedVideoReference] = useState("");
  const [dubbedVideosList, setDubbedVideosList] = useState([]);
  const selectedDubbedVideo = dubbedVideoReference
    ? dubbedVideosList.find((video) => video.url === dubbedVideoReference)
    : null;
  // Download-only versions stay selectable for their downloads, but the
  // player gets no source; load-on-play ones get it once play is pressed.
  const playback = selectedDubbedVideo
    ? versionPlayback(selectedDubbedVideo)
    : PLAYBACK.NOW;
  const downloadOnly = playback === PLAYBACK.DOWNLOAD_ONLY;
  const [loadRequestedFor, setLoadRequestedFor] = useState("");
  const waitingForPlay =
    playback === PLAYBACK.ON_PLAY && loadRequestedFor !== dubbedVideoReference;
  const { playbackUrl: dubbedVideoUrl } = useProjectMediaPlayback({
    reference: downloadOnly ? "" : dubbedVideoReference,
    projectId: projectFile?.id,
  });
  const videoUrl =
    downloadOnly || waitingForPlay
      ? ""
      : dubbedVideoReference
      ? dubbedVideoUrl
      : originalVideoUrl;

  // null until the QA endpoint returns the list (older backends omit it).
  const [dubbedAudiosList, setDubbedAudiosList] = useState(null);
  const [videoUniqueId, setVideoUniqueId] = useState("");
  const [videoVersion, setVideoVersion] = useState("");
  const [srtDownloadLoading, setSrtDownloadLoading] = useState(false);
  const [srtDownloadError, setSrtDownloadError] = useState(null);
  const [attributionDownLoading, setAttributionDownloading] = useState(false);
  const [sidePanelTab, setSidePanelTab] = useState("characters");
  const [isCreatingVersion, setIsCreatingVersion] = useState(false);
  // { generating, ready } from the characters panel, for the tab's dot.
  const [voiceActivity, setVoiceActivity] = useState({
    generating: false,
    ready: false,
  });
  const [videoAspectRatio, setVideoAspectRatio] = useState(
    DEFAULT_VIDEO_ASPECT_RATIO
  );
  const handleVideoSizeChange = useCallback(({ width, height }) => {
    setVideoAspectRatio(width / height);
  }, []);

  const [subtitles, setSubtitles] = useState([]);
  const [showOriginalSubtitles, setShowOriginalSubtitles] = useState(true);
  const [showTranslatedSubtitles, setShowTranslatedSubtitles] = useState(true);

  useEffect(() => {
    if (!projectFile?.id || !languageCode) {
      return;
    }

    const fetchSubtitles = async () => {
      try {
        const response = await axios.post(GET_SRT, {
          projectId: projectFile.id,
          language: languageCode,
          startTime: 0,
          endTime: 100000, // Large enough to cover every subtitle.
        });

        setSubtitles(response.data?.subtitles || []);
      } catch (err) {
        console.error("Error fetching subtitles:", err);
        setSubtitles([]);
        toast.error("Failed to load subtitles");
      }
    };

    fetchSubtitles();
  }, [languageCode, projectFile?.id]);

  const getLanguageDisplayName = (code) => {
    try {
      return new Intl.DisplayNames(["en"], { type: "language" }).of(code);
    } catch (error) {
      return code?.toUpperCase();
    }
  };

  // Reset to the original video when the project changes.
  useEffect(() => {
    setDubbedVideoReference("");
    setVideoVersion("");
    setVideoUniqueId("");
  }, [languageCode, projectFile?.id]);

  useEffect(() => {
    if (!projectFile?.id) {
      return;
    }

    const fetchVersions = async () => {
      try {
        const response = await axios.post(GET_ALL_QUALITYASSURANCE_VERSIONS, {
          projectId: projectFile.id,
          languageCode: languageCode,
        });

        const versions =
          response.data.dubbedVideosList?.filter(
            (item) => item.language === languageCode
          ) || [];

        setDubbedVideosList(versions);
        setDubbedAudiosList(response.data.dubbedAudiosList ?? null);
        setHasSourceVideo(Boolean(response.data.hasSourceVideo));

        // Open on the newest version. A download-only one shows a notice in
        // place of the video, so it never starts a download by itself.
        const latest = latestVersion(versions);

        if (latest) {
          setDubbedVideoReference(latest.url);
          setVideoVersion(latest.version);
          setVideoUniqueId(latest.uniqueId);
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchVersions();
  }, [languageCode, projectFile?.id]);

  const [characters, setCharacters] = useState([]);
  const [audioData, setAudioData] = useState([]);
  useDialoguePlaybackRefresh({
    dialogues: audioData,
    projectId: projectFile?.id,
    setDialogues: setAudioData,
    languageCode,
  });
  const [currentTime, setCurrentTime] = useState(0);
  const [seekTime, setSeekTime] = useState(0);
  const [seekTimeIndex, setSeekTimeIndex] = useState(0);
  // Which list sits under the video: the dialogue lines or the non-verbal
  // sounds detection found.
  const [workSection, setWorkSection] = useState("dialogue");
  const nonverbal = useNonverbalRegions(projectFile?.id);
  const nonverbalInDub = nonverbal.regions.filter(
    (region) => dubStatus(region) !== "out"
  ).length;
  const [scrollableItem, setScrollableItem] = useState(0);
  const [scrollableItemLastUpdated, setScrollableItemLastUpdated] = useState(0);
  const [audioLoader, setAudioLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [versionName, setVersionName] = useState("");
  const [outputAudioLayout, setOutputAudioLayout] = useState(
    DEFAULT_OUTPUT_AUDIO_LAYOUT
  );
  const [videoSource, setVideoSource] = useState(DEFAULT_VIDEO_SOURCE);
  // Whether the project has an original stored; until the versions
  // endpoint says so, only the lower-resolution copy can be chosen.
  const [hasSourceVideo, setHasSourceVideo] = useState(false);

  const [syncPreview, setSyncPreview] = useState(false);
  // Listening volume for dialogue audio during preview; not saved to the dialogue.
  const [previewVolume, setPreviewVolume] = useState(1);
  const [continuePreviewAcrossPages, setContinuePreviewAcrossPages] =
    useState(false);
  const [pendingContinuousPreviewPage, setPendingContinuousPreviewPage] =
    useState(null);
  // Play was pressed while the page's preview clips were still decoding.
  const [previewPlayPending, setPreviewPlayPending] = useState(false);
  const [previewVideoElement, setPreviewVideoElement] = useState(null);

  const [playPausePlayer, setPlayPausePlayer] = useState("pause");

  const numberOfDialogues = projectFile?.numberOfDialogues || 0;

  const timeoutIdRef = useRef(null);

  const [globalEmotions, setGlobalEmotions] = useState({});
  const experimentalTraining = useExperimentalFeature(
    projectFile?.id,
    userInfo?.id,
    projectFile?.name
  );

  const [pageButtonActivity, setPageButtonActivity] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [goToPageNumber, setGoToPageNumber] = useState("");

  // Links can open the page already filtered, e.g. ?attention=chopping-failed
  // from the admin actions page.
  const [linkedFilters] = useState(() => {
    const attention = searchParams.get("attention") || "";
    const known = DIALOGUE_ATTENTION_OPTIONS.some((group) =>
      group.options.some((option) => option.value === attention)
    );
    return known ? { ...DEFAULT_DIALOGUE_SEARCH_FILTERS, attention } : null;
  });
  const pendingLinkedFilters = useRef(linkedFilters);
  const [dialogueSearchFilters, setDialogueSearchFilters] = useState(
    linkedFilters || DEFAULT_DIALOGUE_SEARCH_FILTERS
  );
  const [isDialogueSearchActive, setIsDialogueSearchActive] = useState(false);
  const [searchResultCount, setSearchResultCount] = useState(0);
  // Every line the active filters matched, so their later pages load just
  // those lines instead of filtering the whole project again.
  const searchMatchesRef = useRef(null);
  // The loaded page's first and last lines as the server sent them, for
  // Next and Previous.
  const pageCursorsRef = useRef(null);
  // The next page, loaded in the background: { key, matches, startedAt,
  // promise }.
  const prefetchedPageRef = useRef(null);

  const [inputStartTime, setInputStartTime] = useState({});
  const [inputEndTime, setInputEndTime] = useState({});
  const [subtitleOnlyMap, setSubtitleOnlyMap] = useState({});
  const [vEngineTypeMap, setVEngineTypeMap] = useState({});
  const [performanceCollapsedMap, setPerformanceCollapsedMap] = useState({});
  const [speedSelectionMap, setSpeedSelectionMap] = useState({});
  const [audioAutoPlayRequestMap, setAudioAutoPlayRequestMap] = useState({});

  const itemsPerPage = 10;

  const activeDialogueCount = isDialogueSearchActive
    ? searchResultCount
    : numberOfDialogues;

  const totalPages = Math.max(1, Math.ceil(activeDialogueCount / itemsPerPage));

  const containerRef = useRef(null);
  const performanceToggleButtonWidth = "100px";

  useEffect(() => {
    const fetchEmotions = async () => {
      if (!experimentalTraining) return;

      try {
        const db = getFirestore();
        const emotionsRef = doc(db, "EmotionMappings", "global-dec-2024");
        const emotionsSnap = await getDoc(emotionsRef);

        if (emotionsSnap.exists()) {
          setGlobalEmotions(emotionsSnap.data());
        } else {
          console.log("No emotion mappings found");
        }
      } catch (err) {
        console.error("Error fetching emotion mappings:", err);
      }
    };

    fetchEmotions();
  }, [experimentalTraining]);

  const scrollToItem = (index) => {
    const manpIndex = index;

    if (containerRef.current) {
      const item = containerRef.current.children[manpIndex];
      if (item) {
        item.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  };

  const displayAudioTime = useCallback((data) => {
    setCurrentTime(data);
  }, []);

  function findDisplayName(speaker) {
    return getSpeakerDisplayName(characters, speaker);
  }

  const originalAudioEmotionOptions = useMemo(() => {
    const emotionsFromLoadedDialogues = audioData
      .map((dialogue) => dialogue?.originalAudioEmotion)
      .filter(Boolean);

    const emotionsFromCharacterVoices = characters
      .flatMap((character) => character?.voices || [])
      .map((voice) => voice?.emotion)
      .filter(Boolean);

    return [
      ...new Set([
        "neutral",
        ...emotionsFromLoadedDialogues,
        ...emotionsFromCharacterVoices,
      ]),
    ];
  }, [audioData, characters]);

  const checkTimeInRange = useCallback(
    (currentTimeValue) => {
      if (!audioData) {
        return;
      }

      const numericTime = Number(currentTimeValue);

      if (Number.isNaN(numericTime)) {
        return;
      }

      let itemInTimeRange = null;

      for (const item of audioData) {
        const start = Number(item.start);
        const end = Number(item.end);

        if (Number.isNaN(start) || Number.isNaN(end)) {
          continue;
        }

        if (numericTime >= start && numericTime < end) {
          if (!itemInTimeRange || Number(itemInTimeRange.start) < start) {
            itemInTimeRange = item;
          }
        }
      }

      if (itemInTimeRange) {
        if (itemInTimeRange.id !== scrollableItemLastUpdated) {
          setScrollableItemLastUpdated(itemInTimeRange.id);
          setScrollableItem(itemInTimeRange.id);
        }
      }
    },
    [audioData, scrollableItemLastUpdated]
  );

  useEffect(() => {
    checkTimeInRange(currentTime);
  }, [currentTime, checkTimeInRange]);

  useEffect(() => {
    if (false) {
      if (screenIsOver1200px) {
        scrollToItem(scrollableItem - 1);
      }
    }
  }, [scrollableItem, screenIsOver1200px]);

  const findDefaultEmotion = useCallback(
    (speaker, originalAudioEmotion) => {
      if (experimentalTraining) {
        console.log(
          `used experimental ${globalEmotions[originalAudioEmotion]}`
        );
        return (
          globalEmotions[originalAudioEmotion] ||
          globalEmotions["neutral"] ||
          "dwo0oupDDyJeTBpyE6n3"
        );
      }

      console.log("didn't use experimental");

      return getDefaultVoiceIdForEmotion(
        projectFile?.characters,
        speaker,
        originalAudioEmotion
      );
    },
    [experimentalTraining, globalEmotions, projectFile?.characters]
  );

  function checkTranslationLength(originalLength, translatedLength) {
    return getTranslationDurationMessage(originalLength, translatedLength);
  }

  function getRecommendedSpeedOption(originalLength, translatedLength) {
    return getProjectWorkRecommendedSpeedOption(originalLength, translatedLength);
  }

  const checkLanguage = useCallback(
    (translations = []) => {
      return ensureProjectFinalLanguageTranslations(
        translations,
        projectFile?.finalLang
      );
    },
    [projectFile?.finalLang]
  );

  const findTransObjectsbyLangCode = useCallback(
    (array = []) => findTranslationByLanguageCode(array, languageCode),
    [languageCode]
  );

  const prepareDialogues = useCallback(
    (dialogues = []) => {
      const subtitleMap = {};
      const performanceMap = {};
      const engineMap = {};
      const speedMap = {};

      const hydratedDialogues = dialogues.map((dia, index) => {
        const translations = checkLanguage(dia.translations);
        const selectedTranslation = findTransObjectsbyLangCode(translations);

        const initialVoiceEngine =
          selectedTranslation?.translatedAudioLastUsedModel ||
          dia.translatedAudioLastUsedModel ||
          dia.vEngineType ||
          DEFAULT_VOICE_ENGINE;

        subtitleMap[dia.dbid] = dia.subtitleOnly === true;
        performanceMap[dia.dbid] = dia.approved === true;
        engineMap[dia.dbid] = initialVoiceEngine;
        speedMap[dia.dbid] = "";

        return {
          ...dia,
          id: index,
          vEngineType: initialVoiceEngine,
          tempTransEmotion: findDefaultEmotion(
            dia.speaker,
            dia.originalAudioEmotion
          ),
          translatedAudioDurationTemp: null,
          record: false,
          translations,
          filterShow: true,
          loader: false,
          tempAudioList: selectedTranslation?.translatedAudio
            ? [
                {
                  url: selectedTranslation.translatedAudio,
                  objectPath: selectedTranslation.translatedAudioPath,
                  length: selectedTranslation.translatedAudioDuration,
                  emotion: "original",
                },
              ]
            : [],
        };
      });

      setSubtitleOnlyMap(subtitleMap);
      setPerformanceCollapsedMap(performanceMap);
      setVEngineTypeMap(engineMap);
      setSpeedSelectionMap(speedMap);

      return hydratedDialogues;
    },
    [checkLanguage, findDefaultEmotion, findTransObjectsbyLangCode]
  );

  const findEmotionByVoiceId = (voiceId) => {
    if (experimentalTraining) {
      for (let currEmotion in globalEmotions) {
        if (globalEmotions[currEmotion] === voiceId) {
          return currEmotion;
        }
      }
    }

    for (const character of characters) {
      if (!character.voices || character.voices.length === 0) continue;

      for (const voice of character.voices) {
        if (voice.voice_id === voiceId) {
          return voice.emotion;
        }
      }
    }

    return null;
  };

  const handleVoiceOverLapping = (index, translatedDuration) => {
    const dialogue = audioData[index];
    const nextRowOnPage = audioData[index + 1];
    // Unfiltered rows are contiguous, so the next row is the true next line
    // (and reflects timing edits). Otherwise use the backend's nextStart,
    // which covers lines on the next page or hidden by the active filters.
    const nextStart =
      !isDialogueSearchActive && nextRowOnPage
        ? nextRowOnPage.start
        : dialogue?.nextStart ?? nextRowOnPage?.start;

    return isTranslatedAudioOverlapping(
      dialogue?.start,
      translatedDuration,
      nextStart
    ) ? (
      <span className={classes["DialogueRowStatusTag"]}>Overlapping</span>
    ) : (
      ""
    );
  };

  // Applied right away and saved in the background, so the page isn't
  // blocked; the row goes back to its previous character if the save fails.
  const handleSpeakerChange = async (e, index) => {
    const previousDialogue = audioData[index];
    const updatedData = [...audioData];

    // The voice picked for generation belongs to the old character, so switch
    // it to the new character's default, as a page load would.
    updatedData[index] = {
      ...previousDialogue,
      speaker: e.target.value,
      tempTransEmotion: findDefaultEmotion(
        e.target.value,
        previousDialogue.originalAudioEmotion
      ),
    };

    setAudioData(updatedData);

    try {
      await qaPost(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });
    } catch (err) {
      console.log(err);
      toast.error("Error in changing the character");
      setAudioData((prevData) =>
        prevData.map((dialogue) =>
          dialogue.dbid === previousDialogue.dbid
            ? {
                ...dialogue,
                speaker: previousDialogue.speaker,
                tempTransEmotion: previousDialogue.tempTransEmotion,
              }
            : dialogue
        )
      );
    }
  };

  // Merge / delete confirmation for a dialogue row; null while closed.
  const [rowAction, setRowAction] = useState(null);
  const [rowActionBusy, setRowActionBusy] = useState(false);

  const joinText = (...parts) =>
    parts
      .map((part) => (typeof part === "string" ? part.trim() : ""))
      .filter(Boolean)
      .join(" ");

  // The row above absorbs this one: texts (and each language's translated and
  // subtitle text) are joined and the time range spans both.
  const buildMergedDialogue = (above, current) => {
    const currentTranslations = current.translations || [];
    const translations = (above.translations || []).map((aboveTranslation) => {
      const match = currentTranslations.find(
        (t) => t.languageCode === aboveTranslation.languageCode
      );
      if (!match) {
        return aboveTranslation;
      }

      const merged = {
        ...aboveTranslation,
        translatedText: joinText(
          aboveTranslation.translatedText,
          match.translatedText
        ),
      };
      if (aboveTranslation.srtText || match.srtText) {
        merged.srtText = joinText(
          aboveTranslation.srtText || aboveTranslation.translatedText,
          match.srtText || match.translatedText
        );
      }
      return merged;
    });

    currentTranslations.forEach((t) => {
      if (!translations.some((m) => m.languageCode === t.languageCode)) {
        translations.push(t);
      }
    });

    return {
      ...above,
      text: joinText(above.text, current.text),
      start: Math.min(Number(above.start) || 0, Number(current.start) || 0),
      end: Math.max(Number(above.end) || 0, Number(current.end) || 0),
      translations,
    };
  };

  const openMergeDialog = (index) => {
    const above = audioData[index - 1];
    const current = audioData[index];
    if (!above || !current) {
      return;
    }
    setRowAction({
      type: "merge",
      dialogue: current,
      aboveDialogue: above,
      merged: buildMergedDialogue(above, current),
    });
  };

  const openDeleteDialog = (index) => {
    if (audioData[index]) {
      setRowAction({ type: "delete", dialogue: audioData[index] });
    }
  };

  // Reloads the page after a row is removed, stepping back a page when the
  // last row of the last page went away.
  const reloadAfterRowRemoved = async () => {
    const remainingCount = Math.max(
      0,
      (isDialogueSearchActive ? searchResultCount : numberOfDialogues) - 1
    );
    const lastPage = Math.max(1, Math.ceil(remainingCount / itemsPerPage));
    const targetPage = Math.min(Number(pageNumber) || 1, lastPage);

    ctxDispatch({
      type: "PROJECT_FILE",
      payload: {
        ...projectFile,
        numberOfDialogues: Math.max(0, numberOfDialogues - 1),
      },
    });

    if (isDialogueSearchActive) {
      await loadSearchDialoguesPage(dialogueSearchFilters, targetPage);
    } else {
      await goToPageAPI(targetPage);
    }
  };

  // Newly added row, highlighted and scrolled to once its page loads.
  const [highlightedDialogueId, setHighlightedDialogueId] = useState(null);

  useEffect(() => {
    if (!highlightedDialogueId) {
      return undefined;
    }

    document
      .querySelector(`[data-dialogue-id="${highlightedDialogueId}"]`)
      ?.scrollIntoView({ behavior: "smooth", block: "center" });

    const timer = setTimeout(() => setHighlightedDialogueId(null), 2400);
    return () => clearTimeout(timer);
  }, [highlightedDialogueId, audioData]);

  // Adds an empty dialogue right after this row, for the same character,
  // filling the gap before the next row (up to 2 seconds).
  const handleAddDialogueBelow = async (index) => {
    const current = audioData[index];
    if (!current || !projectFile?.id) {
      return;
    }

    const next = audioData[index + 1];
    const start = Number(current.end) || 0;
    const nextStart = Number(next?.start);
    const end =
      Number.isFinite(nextStart) && nextStart > start
        ? Math.min(nextStart, start + 2)
        : start + 2;

    setRowActionBusy(true);

    try {
      const response = await qaPost(ADD_SPEECH_FOR_PROJECT, {
        projectId: projectFile.id,
        dialogue: {
          speaker: current.speaker,
          text: "",
          start,
          end,
          originalAudioEmotion: current.originalAudioEmotion,
        },
      });

      ctxDispatch({
        type: "PROJECT_FILE",
        payload: { ...projectFile, numberOfDialogues: numberOfDialogues + 1 },
      });

      // A row added after the page's last row lands on the next page.
      const targetPage =
        index === itemsPerPage - 1
          ? (Number(pageNumber) || 1) + 1
          : Number(pageNumber) || 1;

      await goToPageAPI(targetPage);
      setHighlightedDialogueId(response.data || null);
      toast.success("Dialogue added");
    } catch (err) {
      console.error(err);
      toast.error("Error in adding the dialogue");
    } finally {
      setRowActionBusy(false);
    }
  };

  const handleConfirmRowAction = async () => {
    if (!rowAction || !projectFile?.id) {
      return;
    }

    setRowActionBusy(true);
    const { type, dialogue, merged } = rowAction;

    try {
      if (type === "merge") {
        await qaPost(UPDATE_ONE_SPEECH, {
          projectId: projectFile.id,
          dialogue: merged,
        });
      }

      await qaPost(DELETE_SPEECH_FOR_PROJECT, {
        projectId: projectFile.id,
        uid: dialogue.dbid,
      });

      setRowAction(null);
      toast.success(
        type === "merge" ? "Dialogues merged" : "Dialogue deleted"
      );
      await reloadAfterRowRemoved();
    } catch (err) {
      console.error(err);
      toast.error(
        type === "merge"
          ? "Error in merging the dialogues"
          : "Error in deleting the dialogue"
      );
    } finally {
      setRowActionBusy(false);
    }
  };

  const formatTime = (timeInSeconds) => {
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor((timeInSeconds % 3600) / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    const milliseconds = Math.round((timeInSeconds % 1) * 100);

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0"
    )}:${String(seconds).padStart(2, "0")}.${String(milliseconds).padStart(
      2,
      "0"
    )}`;
  };

  useEffect(() => {
    const initialStartTimes = {};
    const initialEndTimes = {};

    audioData.forEach((data, index) => {
      initialStartTimes[index] = formatTime(data.start || 0);
      initialEndTimes[index] = formatTime(data.end || 0);
    });

    setInputStartTime(initialStartTimes);
    setInputEndTime(initialEndTimes);
  }, [audioData]);

  const saveStartTime = useMemo(
    () =>
      debounce(async (data) => {
        try {
          await qaPost(UPDATE_ONE_SPEECH, {
            projectId: projectFile?.id,
            dialogue: data,
          });
        } catch (error) {
          console.error("Error saving start time:", error);
        }
      }, 500),
    [projectFile?.id, qaPost]
  );

  const saveEndTime = useMemo(
    () =>
      debounce(async (data) => {
        try {
          await qaPost(UPDATE_ONE_SPEECH, {
            projectId: projectFile?.id,
            dialogue: data,
          });
        } catch (error) {
          console.error("Error saving end time:", error);
        }
      }, 500),
    [projectFile?.id, qaPost]
  );

  useEffect(() => {
    return () => {
      saveStartTime.cancel?.();
      saveEndTime.cancel?.();
    };
  }, [saveEndTime, saveStartTime]);

  const handleStartTimeChange = (e, index) => {
    const value = e.target.value;

    setInputStartTime((prev) => ({ ...prev, [index]: value }));

    const newTime = parseTimestampAsTotalSeconds(value);
    const updatedData = [...audioData];

    updatedData[index] = { ...updatedData[index], start: newTime };

    setAudioData(updatedData);
    saveStartTime(updatedData[index]);
  };

  const handleEndTimeChange = (e, index) => {
    const value = e.target.value;

    setInputEndTime((prev) => ({ ...prev, [index]: value }));

    const newTime = parseTimestampAsTotalSeconds(value);
    const updatedData = [...audioData];

    updatedData[index] = { ...updatedData[index], end: newTime };

    setAudioData(updatedData);
    saveEndTime(updatedData[index]);
  };

  const getDialogueDurationSeconds = (dialogue) => {
    if (!dialogue) {
      return Number.NaN;
    }

    const rawDuration = Number(dialogue.duration);

    if (!Number.isNaN(rawDuration) && rawDuration > 0) {
      return rawDuration;
    }

    const startSeconds =
      typeof dialogue.start === "number"
        ? dialogue.start
        : parseTimestampAsTotalSeconds(dialogue.start) || 0;

    const endSeconds =
      typeof dialogue.end === "number"
        ? dialogue.end
        : parseTimestampAsTotalSeconds(dialogue.end) || 0;

    const computedDuration = endSeconds - startSeconds;

    return computedDuration > 0 ? computedDuration : Number.NaN;
  };

  function handleNoteChange(e, index) {
    const updatedData = [...audioData];

    updatedData[index].translations = updatedData[index].translations.map(
      (prev) => {
        if (prev.languageCode === languageCode) {
          return {
            ...prev,
            translatedAudioNote: e.target.value,
          };
        }

        return prev;
      }
    );

    clearTimeout(timeoutIdRef.current);

    timeoutIdRef.current = setTimeout(async () => {
      await qaPost(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });
    }, 1650);

    setAudioData(updatedData);
  }

  function handleTextChange(e, index) {
    const updatedData = [...audioData];

    updatedData[index] = {
      ...updatedData[index],
      text: e.target.value,
    };

    setAudioData(updatedData);
    clearTimeout(timeoutIdRef.current);

    timeoutIdRef.current = setTimeout(async () => {
      await qaPost(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });
    }, 1650);
  }

  function handleTranslationChange(e, index) {
    const updatedData = [...audioData];

    updatedData[index].translations = updatedData[index].translations.map(
      (prev) => {
        if (prev.languageCode === languageCode) {
          return {
            ...prev,
            translatedText: e.target.value,
          };
        }

        return prev;
      }
    );

    setAudioData(updatedData);
    clearTimeout(timeoutIdRef.current);

    timeoutIdRef.current = setTimeout(async () => {
      await qaPost(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });
    }, 1650);
  }

  // Focus does not fire again on the box that already has it, so a click on
  // the focused box seeks too. Mousedown runs before focus moves, which tells
  // a repeat click apart from the click that focuses the box.
  const textBoxFocusedOnMouseDownRef = useRef(false);

  const handleTextMouseDown = (event) => {
    textBoxFocusedOnMouseDownRef.current =
      event.currentTarget === document.activeElement;
  };

  const handleTextClick = (index, startTime) => {
    if (textBoxFocusedOnMouseDownRef.current) {
      handleTextFocus(index, startTime);
    }
    textBoxFocusedOnMouseDownRef.current = false;
  };

  function handleTextFocus(index, startTime) {
    const startSeconds =
      typeof startTime === "number"
        ? startTime
        : parseTimestampAsTotalSeconds(startTime) || 0;

    setSeekTime(startSeconds);
    setSeekTimeIndex((prev) => prev + 1);

    const originalPlayer = originalAudioRefs.current[index];

    if (originalPlayer?.audioEl?.current) {
      originalPlayer.audioEl.current.pause();
      originalPlayer.audioEl.current.currentTime = 0;
    }

    const translatedPlayer = translatedAudioRefs.current[index];

    if (translatedPlayer) {
      if (typeof translatedPlayer.pause === "function") {
        translatedPlayer.pause();
      }

      if (typeof translatedPlayer.seek === "function") {
        translatedPlayer.seek(0);
      }
    }

    // The video only seeks: it keeps playing if it was playing and stays
    // paused if it was paused. While previewing, the timeline follows it.
  }

  const handleDialogueRating = async (rating, index) => {
    setAudioLoader(true);

    const updatedData = [...audioData];

    updatedData[index].translations = updatedData[index].translations.map(
      (prev) => {
        if (prev.languageCode === languageCode) {
          return {
            ...prev,
            translatedAudioRating: rating,
          };
        }

        return prev;
      }
    );

    try {
      const response = await qaPost(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });

      if (response.data) {
        setAudioData(updatedData);
        setAudioLoader(false);
      }
    } catch (err) {
      console.log(err);
      setAudioLoader(false);
    }
  };

  // The spinner replaces the +1/+3 button, so it must be cleared whenever a
  // request stops before it is sent, or the button would stay hidden.
  const clearDialogueLoader = (index) => {
    setAudioData((prevData) => {
      const updatedData = [...prevData];
      updatedData[index].loader = false;
      return updatedData;
    });
  };

  const handleNewAudioUrl = async (index) => {
    const now = new Date();
    const storedVoiceEngine =
      vEngineTypeMap[audioData[index].dbid] || DEFAULT_VOICE_ENGINE;
    if (isLegacyVoiceEngine(storedVoiceEngine)) {
      toast.error(
        "Legacy audio remains playable, but generation with this legacy engine is no longer available. Select a supported voice engine to create new audio."
      );
      clearDialogueLoader(index);
      return;
    }

    const selectedVoiceEngine = getSupportedVoiceEngine(storedVoiceEngine);

    const isSoundEffectEngine =
      selectedVoiceEngine === SOUND_EFFECT_VOICE_ENGINE;

    if (!isSoundEffectEngine && audioData[index].tempTransEmotion === "") {
      toast.error("Error !! Choose an emotion");
      clearDialogueLoader(index);
      return;
    }

    const dialogueCopy = {
      ...audioData[index],
      translatedText: findTransObjectsbyLangCode(audioData[index].translations)
        .translatedText,
      languageCode: languageCode,
      loader: false,
      vEngineType: selectedVoiceEngine,
    };

    if (!isSoundEffectEngine) {
      dialogueCopy.voiceId = audioData[index].tempTransEmotion;
      dialogueCopy.emotion = findEmotionByVoiceId(
        audioData[index].tempTransEmotion
      );
    } else {
      dialogueCopy.voiceId = null;
      dialogueCopy.emotion = null;
    }

    const requestBody = isSoundEffectEngine
      ? {
          projectId: projectFile.id,
          dialogueID: audioData[index].dbid,
          prompt_influence: 0.5,
          vEngineType: SOUND_EFFECT_VOICE_ENGINE,
          dialogue: dialogueCopy,
        }
      : {
          dialogue: dialogueCopy,
          projectName: projectFile.name,
          creationDate: projectFile.creationDate,
          projectId: projectFile.id,
          vEngineType: selectedVoiceEngine,
        };

    const hasRequiredFields = isSoundEffectEngine
      ? requestBody.dialogue && requestBody.projectId && requestBody.dialogueID
      : requestBody.dialogue &&
        requestBody.projectId &&
        requestBody.projectName;

    if (!hasRequiredFields) {
      toast.error("Missing data required to create new audio");
      clearDialogueLoader(index);
      return;
    }

    try {
      const endpoint = isSoundEffectEngine
        ? GENERATE_SOUND_EFFECT
        : CREATE_NEW_AUDIO;

      const headers = await injectToken();
      console.log("Headers:", headers);

      // const response = await axios.post(endpoint, requestBody);
      const response = await qaPost(endpoint, requestBody, {
        headers,
      });
      // const response = await fetch(endpoint, {
      //                 method: "POST",
      //                 headers: await injectToken(userInfo.id),
      //                 body: JSON.stringify(requestBody),
      //             });

      const generatedAudio = readAudioClientResponse(response.data);
      const durableAudioReference =
        generatedAudio.objectPath || generatedAudio.playbackUrl;
      if (!durableAudioReference || !generatedAudio.playbackUrl) {
        throw new Error("Audio generation response is missing media access data");
      }

      const newAudioObject = {
        url: generatedAudio.playbackUrl,
        objectPath: generatedAudio.objectPath,
        creationTime: now,
        emotion: isSoundEffectEngine ? null : audioData[index].tempTransEmotion,
        translatedAudioDuration: generatedAudio.durationSeconds,
      };

      const persistedTranslations = dialogueCopy.translations.map((prev) => {
        if (prev.languageCode === languageCode) {
          const persistedVersion = {
            ...newAudioObject,
            url: durableAudioReference,
          };
          return {
            ...prev,
            translatedAudio: durableAudioReference,
            ...(generatedAudio.objectPath
              ? { translatedAudioPath: generatedAudio.objectPath }
              : {}),
            translatedAudioDuration: newAudioObject.translatedAudioDuration,
            translatedAudioList: prev.translatedAudioList
              ? [...prev.translatedAudioList, persistedVersion]
              : [persistedVersion],
          };
        }

        return prev;
      });

      const dialogueToPersist = {
        ...dialogueCopy,
        translations: persistedTranslations,
      };

      await qaPost(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: dialogueToPersist,
      });

      const localDialogue = {
        ...dialogueCopy,
        translations: persistedTranslations.map((translation) =>
          translation.languageCode === languageCode
            ? {
                ...translation,
                translatedAudio: generatedAudio.playbackUrl,
                translatedAudioPath: generatedAudio.objectPath,
              }
            : translation
        ),
      };

      const newSingleAudio = {
        url: generatedAudio.playbackUrl,
        objectPath: generatedAudio.objectPath,
        length: generatedAudio.durationSeconds,
        emotion: generatedAudio.emotion,
      };

      setAudioData((prevData) => {
        const updatedData = [...prevData];

        const updatedTempAudioList = [
          ...updatedData[index].tempAudioList,
          newSingleAudio,
        ];

        updatedData[index] = {
          ...localDialogue,
          tempAudioList: updatedTempAudioList,
        };

        return updatedData;
      });

      setAudioAutoPlayRequestMap((previousRequests) => ({
        ...previousRequests,
        [audioData[index].dbid]:
          (previousRequests[audioData[index].dbid] || 0) + 1,
      }));

      toast.success("New Audio has been added", {
        hideProgressBar: false,
        autoClose: 1000,
      });
    } catch (err) {
      console.error(err);
      toast.error("Error in creating new audio");

      setAudioData((prevData) => {
        const updatedData = [...prevData];
        updatedData[index].loader = false;
        return updatedData;
      });
    }
  };

  const handleMultipleAudio = async (index) => {
    if (audioData[index].tempTransEmotion === "") {
      toast.error("Error !! Choose an emotion");
      clearDialogueLoader(index);
      return;
    }

    const storedVoiceEngine =
      vEngineTypeMap[audioData[index].dbid] || DEFAULT_VOICE_ENGINE;
    if (isLegacyVoiceEngine(storedVoiceEngine)) {
      toast.error(
        "Legacy audio remains playable, but generation with this legacy engine is no longer available. Select a supported voice engine to create multiple takes."
      );
      clearDialogueLoader(index);
      return;
    }

    const selectedVoiceEngine = getSupportedVoiceEngine(storedVoiceEngine);

    if (selectedVoiceEngine === SOUND_EFFECT_VOICE_ENGINE) {
      toast.error(
        "Multiple takes are not available for the selected voice engine"
      );
      clearDialogueLoader(index);
      return;
    }

    const dialogueCopy = {
      ...audioData[index],
      translatedText: findTransObjectsbyLangCode(audioData[index].translations)
        .translatedText,
      voiceId: audioData[index].tempTransEmotion,
      languageCode: languageCode,
      emotion: findEmotionByVoiceId(audioData[index].tempTransEmotion),
      loader: false,
      vEngineType: selectedVoiceEngine,
    };

    const targetDurationSeconds = getDialogueDurationSeconds(dialogueCopy);

    const requestBody = {
      dialogue: dialogueCopy,
      projectName: projectFile.name,
      creationDate: projectFile.creationDate,
      projectId: projectFile.id,
      targetDuration: targetDurationSeconds,
      vEngineType: selectedVoiceEngine,
    };

    if (
      !requestBody.dialogue ||
      !requestBody.projectId ||
      !requestBody.projectName
    ) {
      toast.error("Missing data required to create multiple audio takes");
      clearDialogueLoader(index);
      return;
    }

    try {
      const headers = await injectToken();

      const response = await qaPost(CREATE_MULTIPLE_AUDIO, requestBody, {
        headers,
      });
      const generatedAudios = response.data.map((item) => {
        const generated = readAudioClientResponse(item);
        return {
          ...item,
          url: generated.playbackUrl,
          objectPath: generated.objectPath,
          length: generated.durationSeconds,
          emotion: generated.emotion,
        };
      });

      setAudioData((prevData) => {
        const updatedData = [...prevData];
        const existingAudioList = updatedData[index].tempAudioList;

        const newAudioList = generatedAudios.filter(
          (newAudio) =>
            !existingAudioList.some(
              (existingAudio) => existingAudio.url === newAudio.url
            )
        );

        updatedData[index].tempAudioList = [
          ...existingAudioList,
          ...newAudioList,
        ];
        updatedData[index].loader = false;

        return updatedData;
      });

      toast.success("New audio list has been added", {
        hideProgressBar: false,
        autoClose: 1000,
      });
    } catch (err) {
      console.error(err);
      toast.error("Error in creating new audio");

      setAudioData((prevData) => {
        const updatedData = [...prevData];
        updatedData[index].loader = false;
        return updatedData;
      });
    }
  };

  const selectAudioOption = async (e, index, playerIndex) => {
    const now = new Date();
    const selectedAudioReference = e.target.value;

    if (selectedAudioReference === "") {
      toast.error("Select an audio!");
      return;
    }

    const selectedAudio = audioData[index].tempAudioList.find(
      (audio) =>
        getGeneratedAudioOptionValue(audio) === selectedAudioReference
    );
    if (!selectedAudio) {
      toast.error("The selected audio is no longer available");
      return;
    }

    const audioUrl = selectedAudio.url;
    const audioDuration = selectedAudio.length;
    const objectPath = selectedAudio.objectPath || audioUrl;

    const dialogueCopy = audioData[index];

    const newAudioObject = {
      url: audioUrl,
      translatedAudioDuration: audioDuration,
      creationTime: now,
      emotion: audioData[index].tempTransEmotion,
    };

    const persistedTranslations = dialogueCopy.translations.map((prev) => {
      if (prev.languageCode === languageCode) {
        return {
          ...prev,
          translatedAudio: objectPath,
          translatedAudioPath: selectedAudio.objectPath || null,
          translatedAudioDuration: newAudioObject.translatedAudioDuration,
        };
      }

      return prev;
    });

    const dialogueToPersist = {
      ...dialogueCopy,
      translations: persistedTranslations,
    };
    const localDialogue = {
      ...dialogueCopy,
      translations: persistedTranslations.map((translation) =>
        translation.languageCode === languageCode
          ? {
              ...translation,
              translatedAudio: audioUrl,
            }
          : translation
      ),
    };

    try {
      await qaPost(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: dialogueToPersist,
      });

      setAudioData((prevData) => {
        const updatedData = [...prevData];
        updatedData[index] = localDialogue;
        return updatedData;
      });

      setTimeout(() => {
        if (translatedAudioRefs.current[playerIndex]) {
          translatedAudioRefs.current[playerIndex].seek(0);
          translatedAudioRefs.current[playerIndex].play();
        }
      }, 1000);

      toast.info(" Audio has been updated", {
        hideProgressBar: false,
        autoClose: 1000,
      });
    } catch (error) {
      console.error(error);

      setAudioData((prevData) => {
        const updatedData = [...prevData];
        updatedData[index].loader = false;
        return updatedData;
      });
    }
  };

  const handleAdjustSpeed = async (dialogue, requestedSpeed) => {
    if (!dialogue) {
      toast.error("Dialogue details are not available.");
      return;
    }

    if (!projectFile?.name) {
      toast.error("Project name is required to adjust audio speed.");
      return;
    }

    const selectedSpeed =
      requestedSpeed || speedSelectionMap[dialogue.dbid] || "auto";

    const dialogueWithLanguageCode = {
      ...dialogue,
      languageCode: dialogue.languageCode || languageCode,
    };

    try {
      setAudioLoader(true);

      let response;
      const headers = await injectToken();

      if (selectedSpeed === "auto") {
        response = await qaPost(
          ADJUST_AUDIO_SPEED_AUTO,
          {
            dialogue: dialogueWithLanguageCode,
            projectId: projectFile.id,
            projectName: projectFile.name,
          },
          { headers }
        );
      } else {
        response = await qaPost(
          ADJUST_AUDIO_SPEED,
          {
            dialogue: dialogueWithLanguageCode,
            projectId: projectFile.id,
            projectName: projectFile.name,
            speed: selectedSpeed,
          },
          { headers }
        );
      }

      const adjustedAudio = readAudioClientResponse(response?.data);
      const adjustedAudioUrl = adjustedAudio.playbackUrl;
      const durableAudioReference =
        adjustedAudio.objectPath || adjustedAudio.playbackUrl;
      let dialogueToPersist = dialogue;

      if (adjustedAudioUrl) {
        const adjustedAudioEntry = {
          url: adjustedAudioUrl,
          objectPath: adjustedAudio.objectPath,
          length: adjustedAudio.durationSeconds,
          emotion: `${selectedSpeed}x`,
        };
        dialogueToPersist = {
          ...dialogue,
          translations: dialogue.translations.map((translation) =>
            translation.languageCode === languageCode
              ? {
                  ...translation,
                  translatedAudio: durableAudioReference,
                  ...(adjustedAudio.objectPath
                    ? { translatedAudioPath: adjustedAudio.objectPath }
                    : {}),
                  translatedAudioDuration:
                    adjustedAudioEntry.length ||
                    translation.translatedAudioDuration,
                }
              : translation
          ),
        };

        setAudioData((prevData) => {
          const updatedData = prevData.map((row) => {
            if (row.dbid !== dialogue.dbid) {
              return row;
            }

            const updatedTempAudioList = row.tempAudioList.some(
              (audio) => audio.url === adjustedAudioEntry.url
            )
              ? row.tempAudioList
              : [...row.tempAudioList, adjustedAudioEntry];

            const updatedTranslations = row.translations.map((translation) =>
              translation.languageCode === languageCode
                ? {
                    ...translation,
                    translatedAudio: adjustedAudioUrl,
                    ...(adjustedAudio.objectPath
                      ? { translatedAudioPath: adjustedAudio.objectPath }
                      : {}),
                    translatedAudioDuration:
                      adjustedAudioEntry.length ||
                      translation.translatedAudioDuration,
                  }
                : translation
            );

            return {
              ...row,
              tempAudioList: updatedTempAudioList,
              translations: updatedTranslations,
            };
          });

          return updatedData;
        });
      }

      await qaPost(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: dialogueToPersist,
      });

      toast.success(
        `Requested ${
          selectedSpeed === "auto" ? "automatic" : `${selectedSpeed}x`
        } speed adjustment.`
      );
    } catch (error) {
      console.error("Error adjusting audio speed:", error);
      toast.error(
        error.response?.data?.message || "Failed to adjust audio speed."
      );
    } finally {
      setAudioLoader(false);
    }
  };

  const handleTranslatedAudioVolume = async (e, index) => {
    const dialogueCopy = audioData[index];

    let volume;
    const data = e.target.value;

    if (data === null || data === "") {
      volume = null;
    } else if (isNaN(data)) {
      volume = null;
    } else {
      volume = Number(data);
    }

    dialogueCopy.translations = dialogueCopy.translations.map((prev) => {
      if (prev.languageCode === languageCode) {
        return {
          ...prev,
          translatedAudioVolume: volume,
        };
      }

      return prev;
    });

    try {
      await qaPost(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: dialogueCopy,
      });

      setAudioData((prevData) => {
        const updatedData = [...prevData];
        updatedData[index] = dialogueCopy;
        return updatedData;
      });

      toast.info(" Audio has been updated", {
        hideProgressBar: false,
        autoClose: 1000,
      });
    } catch (error) {
      console.error(error);

      setAudioData((prevData) => {
        const updatedData = [...prevData];
        return updatedData;
      });
    }
  };

  const handleKeepOriginalText = async (index) => {
    setAudioLoader(true);

    const updatedData = [...audioData];

    updatedData[index] = {
      ...updatedData[index],
      keepOriginalText: !updatedData[index].keepOriginalText,
    };

    setAudioData(updatedData);

    try {
      const response = await qaPost(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });

      if (response.data) {
        setAudioData(updatedData);
        setAudioLoader(false);
      }
    } catch (err) {
      console.log(err);
      setAudioLoader(false);
    }
  };

  const finalSubmission = async () => {
    if (!versionName) {
      toast.error("Enter an version name");
      return;
    }

    try {
      setIsCreatingVersion(true);
      await qaPost(MERGING_FULL_API, {
        projectId: projectFile.id,
        projectName: projectFile.name,
        langCode: languageCode,
        version: versionName,
        // The backend adds the developers (DEV_NOTIFICATION_EMAILS).
        emails: [userInfo.email].filter(Boolean),
        submitterName: userInfo.name,
        outputAudioLayout,
        videoSource,
      });

      toast.success("New version is being processed");
      setVersionName("");
      setOutputAudioLayout(DEFAULT_OUTPUT_AUDIO_LAYOUT);
      setVideoSource(DEFAULT_VIDEO_SOURCE);
    } catch (err) {
      console.log(err);
      toast.error(
        err.response?.data?.error ||
          err.response?.data?.message ||
          "Error submitting version"
      );
    } finally {
      setIsCreatingVersion(false);
    }
  };

  const stopCurrentPageAudio = useCallback(() => {
    translatedAudioRefs.current.forEach((audioEl) => {
      if (audioEl?.pause) {
        audioEl.pause();
      }

      if (audioEl?.seek) {
        audioEl.seek(0);
      }
    });

    originalAudioRefs.current.forEach((audioEl) => {
      const player = audioEl?.audioEl?.current;

      if (player) {
        player.pause();
        player.currentTime = 0;
      }
    });

    setPlayPausePlayer("pause");
  }, []);

  const rememberPageCursors = (dialogues = []) => {
    const toCursor = (dialogue) =>
      dialogue?.dbid ? { start: dialogue.start ?? null, id: dialogue.dbid } : null;

    pageCursorsRef.current = {
      first: toCursor(dialogues[0]),
      last: toCursor(dialogues[dialogues.length - 1]),
    };
  };

  const getDialoguesFromResponse = (responseData) => {
    return (
      responseData?.projectsArray ||
      responseData?.dialogues ||
      responseData?.results ||
      []
    );
  };

  const getDialogueCountFromResponse = (responseData, fallbackCount) => {
    return Number(
      responseData?.totalCount ??
        responseData?.count ??
        responseData?.numberOfDialogues ??
        fallbackCount ??
        0
    );
  };

  // A page's dialogues as the server sent them, and with playback URLs.
  const requestDialoguePage = useCallback(
    async ({ action, cursor, pageNumber: target }) => {
      const response = await axios.post(GET_SPEECH_FOR_PROJECT_BY_PAGE, {
        userId: userInfo.id,
        projectId: projectFile.id,
        action,
        cursor,
        pageNumber: target,
        pageName: "voiceqa",
      });
      const dialogues = response.data?.projectsArray || [];
      const hydratedDialogues = await hydrateDialoguePlaybackUrls(
        dialogues,
        projectFile.id,
        { languageCode }
      );
      return { dialogues, hydratedDialogues };
    },
    [languageCode, projectFile?.id, userInfo?.id]
  );

  const requestSearchMatchesPage = useCallback(
    async (matches, target) => {
      const startIndex = (Number(target) - 1) * itemsPerPage;
      const response = await axios.post(SEARCH_SPEECH_FOR_PROJECT, {
        userId: userInfo.id,
        projectId: projectFile.id,
        pageName: "voiceqa",
        languageCode,
        translationLanguageCode: languageCode,
        pageDialogues: matches.slice(startIndex, startIndex + itemsPerPage),
      });
      const dialogues =
        response.data?.projectsArray ||
        response.data?.dialogues ||
        response.data?.results ||
        [];
      const hydratedDialogues = await hydrateDialoguePlaybackUrls(
        dialogues,
        projectFile.id,
        { languageCode }
      );
      return { dialogues, hydratedDialogues };
    },
    [languageCode, projectFile?.id, userInfo?.id]
  );

  // Loads the page after the one just shown in the background, so Next can
  // show it at once. Pages of an active search need its matches.
  const prefetchNextPage = useCallback(
    ({ dialogues = [], shownPage, search = false }) => {
      prefetchedPageRef.current = null;
      if (!projectFile?.id || !userInfo?.id) {
        return;
      }

      const nextPage = Number(shownPage) + 1;
      const matches = search ? searchMatchesRef.current : null;
      let key;
      let promise;

      if (search) {
        if (!matches || (nextPage - 1) * itemsPerPage >= matches.length) {
          return;
        }
        key = `${languageCode}:search:${nextPage}`;
        promise = requestSearchMatchesPage(matches, nextPage);
      } else {
        const lastLine = dialogues[dialogues.length - 1];
        if (dialogues.length < itemsPerPage || !lastLine?.dbid) {
          return;
        }
        key = `${languageCode}:after:${lastLine.dbid}`;
        promise = requestDialoguePage({
          action: "next",
          cursor: { start: lastLine.start ?? null, id: lastLine.dbid },
          pageNumber: nextPage,
        });
      }

      // A failed prefetch only means Next loads the page itself.
      promise.catch(() => {});
      prefetchedPageRef.current = {
        key,
        matches,
        startedAt: Date.now(),
        promise,
      };
    },
    [
      languageCode,
      projectFile?.id,
      requestDialoguePage,
      requestSearchMatchesPage,
      userInfo?.id,
    ]
  );

  // The prefetched page if it's the one asked for and recent enough, else
  // null. Either way the prefetch is used up.
  const takePrefetchedPage = async (key, matches = null) => {
    const prefetched = prefetchedPageRef.current;
    prefetchedPageRef.current = null;

    if (
      !prefetched ||
      prefetched.key !== key ||
      prefetched.matches !== matches ||
      Date.now() - prefetched.startedAt > PREFETCHED_PAGE_MAX_AGE_MS
    ) {
      return null;
    }
    return prefetched.promise.catch(() => null);
  };

  const loadSearchDialoguesPage = useCallback(
    async (filters, targetPageNumber = 1) => {
      if (!projectFile?.id || !userInfo?.id) {
        return;
      }

      setLoader(true);
      setPageButtonActivity(true);

      try {
        stopCurrentPageAudio();

        // Filters only (no text search); the backend evaluates them on live
        // dialogue data for this page's translation language.
        const response = await axios.post(SEARCH_SPEECH_FOR_PROJECT, {
          userId: userInfo.id,
          projectId: projectFile.id,
          pageName: "voiceqa",
          pageNumber: Number(targetPageNumber),
          itemsPerPage,
          languageCode,
          speaker: filters.speaker || "",
          originalAudioEmotion: filters.originalAudioEmotion || "",
          hasTranslatedAudio: filters.hasTranslatedAudio || "",
          hasNote: filters.hasNote || "",
          closed: filters.closed || "",
          ...lineTypeSearchParams(filters.lineType),
          attention: filters.attention || "",
          translationLanguageCode: languageCode,
        });

        const dialogues = getDialoguesFromResponse(response.data);
        const totalCount = getDialogueCountFromResponse(
          response.data,
          dialogues.length
        );
        searchMatchesRef.current = Array.isArray(response.data?.matches)
          ? response.data.matches
          : null;
        const hydratedDialogues = await hydrateDialoguePlaybackUrls(
          dialogues,
          projectFile.id,
          { languageCode }
        );

        setAudioData(prepareDialogues(hydratedDialogues));
        setSearchResultCount(totalCount);
        setIsDialogueSearchActive(hasAnyDialogueSearchFilter(filters));
        setPageNumber(Number(targetPageNumber));
        setGoToPageNumber("");
        prefetchNextPage({ shownPage: targetPageNumber, search: true });
        return true;
      } catch (err) {
        console.error(err);
        toast.error("Error in searching dialogues");
        return false;
      } finally {
        setLoader(false);
        setPageButtonActivity(false);
      }
    },
    [
      languageCode,
      prefetchNextPage,
      projectFile?.id,
      prepareDialogues,
      stopCurrentPageAudio,
      userInfo?.id,
    ]
  );

  // A page of the active search's matches; false when there are none to page
  // through, so the caller runs the search again.
  const loadSearchMatchesPage = useCallback(
    async (targetPageNumber) => {
      const matches = searchMatchesRef.current;

      if (!matches || !projectFile?.id || !userInfo?.id) {
        return false;
      }

      setLoader(true);
      setPageButtonActivity(true);

      try {
        stopCurrentPageAudio();

        const { hydratedDialogues } =
          (await takePrefetchedPage(
            `${languageCode}:search:${Number(targetPageNumber)}`,
            matches
          )) || (await requestSearchMatchesPage(matches, targetPageNumber));

        setAudioData(prepareDialogues(hydratedDialogues));
        setPageNumber(Number(targetPageNumber));
        setGoToPageNumber("");
        prefetchNextPage({ shownPage: targetPageNumber, search: true });
        return true;
      } catch (err) {
        console.error(err);
        toast.error("Error in searching dialogues");
        return true;
      } finally {
        setLoader(false);
        setPageButtonActivity(false);
      }
    },
    [
      languageCode,
      prefetchNextPage,
      prepareDialogues,
      projectFile?.id,
      requestSearchMatchesPage,
      stopCurrentPageAudio,
      userInfo?.id,
    ]
  );

  const loadFirstDialoguePage = useCallback(async () => {
    if (!projectFile?.id || !userInfo?.id) {
      return;
    }

    setLoader(true);

    try {
      stopCurrentPageAudio();

      const response = await axios.post(GET_SPEECH_FOR_PROJECT_BY_PAGE, {
        userId: userInfo.id,
        projectId: projectFile.id,
        action: "first",
        Current: null,
        pageName: "voiceqa",
      });

      const dialogues = await response.data.projectsArray;
      rememberPageCursors(dialogues);
      const hydratedDialogues = await hydrateDialoguePlaybackUrls(
        dialogues,
        projectFile.id,
        { languageCode }
      );

      setAudioData(prepareDialogues(hydratedDialogues));
      setPageNumber(1);
      setGoToPageNumber("");
      prefetchNextPage({ dialogues, shownPage: 1 });
    } catch (err) {
      console.log(err);
      toast.error("Error in getting dialogues");
    } finally {
      setLoader(false);
    }
  }, [
    languageCode,
    prefetchNextPage,
    prepareDialogues,
    projectFile?.id,
    stopCurrentPageAudio,
    userInfo?.id,
  ]);

  // Once the filters change here, the link's filter no longer applies.
  const clearLinkedFilters = () => {
    pendingLinkedFilters.current = null;
    if (searchParams.has("attention")) {
      setSearchParams(
        (previous) => {
          const next = new URLSearchParams(previous);
          next.delete("attention");
          return next;
        },
        { replace: true }
      );
    }
  };

  const handleDialogueSearch = async (filters) => {
    clearLinkedFilters();
    const normalizedFilters = {
      ...DEFAULT_DIALOGUE_SEARCH_FILTERS,
      ...filters,
      searchText: filters.searchText?.trim() || "",
    };

    setDialogueSearchFilters(normalizedFilters);

    if (!hasAnyDialogueSearchFilter(normalizedFilters)) {
      setIsDialogueSearchActive(false);
      setSearchResultCount(0);
      await loadFirstDialoguePage();
      return;
    }

    await loadSearchDialoguesPage(normalizedFilters, 1);
  };

  const handleClearDialogueSearch = async () => {
    clearLinkedFilters();
    setDialogueSearchFilters(DEFAULT_DIALOGUE_SEARCH_FILTERS);
    setIsDialogueSearchActive(false);
    setSearchResultCount(0);
    await loadFirstDialoguePage();
  };

  const nextPrevPageAPI = useCallback(async (action) => {
    setPageButtonActivity(true);

    const targetPageNumber =
      action === "next" ? Number(pageNumber) + 1 : Number(pageNumber) - 1;

    if (targetPageNumber < 1 || targetPageNumber > totalPages) {
      setPageButtonActivity(false);
      return false;
    }

    if (isDialogueSearchActive) {
      return (
        (await loadSearchMatchesPage(targetPageNumber)) ||
        loadSearchDialoguesPage(dialogueSearchFilters, targetPageNumber)
      );
    }

    try {
      stopCurrentPageAudio();

      const cursor =
        action === "next"
          ? pageCursorsRef.current?.last
          : pageCursorsRef.current?.first;
      const prefetched =
        action === "next" && cursor
          ? await takePrefetchedPage(`${languageCode}:after:${cursor.id}`)
          : null;
      const { dialogues, hydratedDialogues } =
        prefetched ||
        (await requestDialoguePage({
          action,
          cursor,
          pageNumber: targetPageNumber,
        }));

      rememberPageCursors(dialogues);
      setAudioData(prepareDialogues(hydratedDialogues));
      setPageNumber(targetPageNumber);
      setPageButtonActivity(false);
      prefetchNextPage({ dialogues, shownPage: targetPageNumber });
      return true;
    } catch (err) {
      console.log(err);
      toast.error("Error in getting the next page");
      setPageButtonActivity(false);
      return false;
    }
  }, [
    dialogueSearchFilters,
    isDialogueSearchActive,
    languageCode,
    loadSearchDialoguesPage,
    loadSearchMatchesPage,
    pageNumber,
    prefetchNextPage,
    prepareDialogues,
    requestDialoguePage,
    stopCurrentPageAudio,
    totalPages,
  ]);

  const goToPageAPI = async (number) => {
    const targetPageNumber = Math.max(1, Number(number) || 1);

    if (isDialogueSearchActive) {
      if (!(await loadSearchMatchesPage(targetPageNumber))) {
        await loadSearchDialoguesPage(dialogueSearchFilters, targetPageNumber);
      }
      return;
    }

    setLoader(true);

    try {
      stopCurrentPageAudio();

      const response = await axios.post(GET_SPEECH_FOR_PROJECT_BY_PAGE, {
        userId: userInfo.id,
        projectId: projectFile.id,
        action: "goto",
        pageNumber: targetPageNumber,
        pageName: "voiceqa",
      });

      if (response.data) {
        const dialogues = await response.data.projectsArray;
        rememberPageCursors(dialogues);
        const hydratedDialogues = await hydrateDialoguePlaybackUrls(
          dialogues,
          projectFile.id,
          { languageCode }
        );

        setAudioData(prepareDialogues(hydratedDialogues));
        setGoToPageNumber("");
        setPageNumber(targetPageNumber);
        setLoader(false);
        prefetchNextPage({ dialogues, shownPage: targetPageNumber });
      }
    } catch (err) {
      setLoader(false);
      console.log(err);
      toast.error("Error in getting the next page");
    }
  };

  // Skip buttons only reload the dialogue list when they land outside the
  // dialogues already loaded.
  const goToPageIfTimeNotLoaded = (timeSeconds) => {
    const starts = (audioData || [])
      .map((dialogue) => Number(dialogue?.start))
      .filter((start) => Number.isFinite(start));
    const pageEndTime = getDialoguePageEndTime(audioData);

    if (
      starts.length > 0 &&
      pageEndTime !== null &&
      timeSeconds >= Math.min(...starts) &&
      timeSeconds < pageEndTime
    ) {
      return;
    }

    goToPageAccordingTimeAPI(timeSeconds);
  };

  const goToPageAccordingTimeAPI = async (timeOverride) => {
    setLoader(true);

    try {
      stopCurrentPageAudio();

      const effectiveTime =
        typeof timeOverride === "number" && !Number.isNaN(timeOverride)
          ? timeOverride
          : parseFloat(currentTime) || 0;

      const positionResponse = await axios.post(
        GET_SPEECH_POSITION_AROUND_TIME,
        {
          projectId: projectFile.id,
          time: effectiveTime,
        }
      );

      const firstPosition = Math.max(
        1,
        Number(positionResponse.data?.firstPosition) || 1
      );

      const targetPage = Math.max(1, Math.ceil(firstPosition / itemsPerPage));

      const targetScrollableIndex = Math.max(
        0,
        (firstPosition - 1) % itemsPerPage
      );

      const response = await axios.post(GET_SPEECH_FOR_PROJECT_BY_PAGE, {
        userId: userInfo.id,
        projectId: projectFile.id,
        action: "goto",
        pageNumber: targetPage,
        pageName: "voiceqa",
      });

      if (response.data) {
        const dialogues = await response.data.projectsArray;
        rememberPageCursors(dialogues);
        const hydratedDialogues = await hydrateDialoguePlaybackUrls(
          dialogues,
          projectFile.id,
          { languageCode }
        );

        setDialogueSearchFilters(DEFAULT_DIALOGUE_SEARCH_FILTERS);
        setIsDialogueSearchActive(false);
        setSearchResultCount(0);

        setAudioData(prepareDialogues(hydratedDialogues));
        setGoToPageNumber("");
        setPageNumber(targetPage);
        setScrollableItemLastUpdated(targetScrollableIndex);
        setScrollableItem(targetScrollableIndex);
        prefetchNextPage({ dialogues, shownPage: targetPage });
      }

      setLoader(false);
    } catch (err) {
      setLoader(false);
      console.log(err);
      toast.error("Error in getting the next page");
    }
  };

  // Also reloaded after a voice is added in the Characters panel, so it shows
  // up in the dialogue rows' voice lists.
  const [charactersLoaded, setCharactersLoaded] = useState(false);
  const reloadCharacters = useCallback(async () => {
    if (!projectFile?.id) {
      return;
    }

    try {
      const response = await axios.post(GET_CHARACTERS_FOR_PROJECT, {
        projectId: projectFile.id,
      });

      setCharacters(response.data.characters);
    } catch (err) {
      console.log(err);
    } finally {
      setCharactersLoaded(true);
    }
  }, [projectFile?.id]);

  useEffect(() => {
    reloadCharacters();
  }, [reloadCharacters]);

  useEffect(() => {
    const filters = pendingLinkedFilters.current;
    if (!filters) {
      loadFirstDialoguePage();
      return;
    }
    // Returns undefined until the project and user are loaded.
    loadSearchDialoguesPage(filters, 1).then((loaded) => {
      if (loaded !== undefined) {
        pendingLinkedFilters.current = null;
      }
    });
  }, [loadFirstDialoguePage, loadSearchDialoguesPage]);

  const stopAllOtherAudio = useCallback((currentId) => {
    translatedAudioRefs.current.forEach((player, index) => {
      if (player && index !== currentId) {
        player.pause();
      }
    });

    originalAudioRefs.current.forEach((player, index) => {
      if (player && index !== currentId && player.audioEl.current) {
        player.audioEl.current.pause();
      }
    });
  }, []);

  // The preview plays the whole page as one timeline over the video, with the
  // M&E stems underneath; it only re-plans when the clips themselves change.
  const latestPreviewClips = buildPreviewClips(
    audioData,
    findTransObjectsbyLangCode
  );
  const previewClipsSignature = getPreviewClipsSignature(latestPreviewClips);
  const previewClips = useMemo(
    () => latestPreviewClips,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [previewClipsSignature]
  );

  const [musicEffectsReference, secondMusicEffectsReference] =
    pickMusicEffectsStemReferences(projectFile?.uploadedAudioTypes);
  const { playbackUrl: musicEffectsUrl } = useProjectMediaPlayback({
    reference: musicEffectsReference || "",
    projectId: projectFile?.id,
  });
  const { playbackUrl: secondMusicEffectsUrl } = useProjectMediaPlayback({
    reference: secondMusicEffectsReference || "",
    projectId: projectFile?.id,
  });
  const previewStemUrls = useMemo(
    () => [musicEffectsUrl, secondMusicEffectsUrl].filter(Boolean),
    [musicEffectsUrl, secondMusicEffectsUrl]
  );

  const {
    ready: previewReady,
    endTime: previewTimelineEndTime,
    unlock: unlockPreviewAudio,
  } = usePagePreviewTimeline({
    enabled: syncPreview,
    videoElement: previewVideoElement,
    clips: previewClips,
    dialogueVolume: previewVolume,
    stemUrls: previewStemUrls,
  });

  const requestSyncPlay = useCallback(() => {
    // Runs inside the Play click, so the browser lets the preview audio start.
    unlockPreviewAudio();
    stopAllOtherAudio(null);

    if (!previewReady) {
      setPreviewPlayPending(true);
      toast.info("Loading preview audio…", {
        toastId: "preview-audio-loading",
        autoClose: 1500,
      });
      return;
    }

    setPreviewPlayPending(false);
    setPlayPausePlayer("play");
  }, [previewReady, stopAllOtherAudio, unlockPreviewAudio]);

  const requestSyncPause = useCallback(() => {
    translatedAudioRefs.current.forEach((p) => p?.pause?.());
    originalAudioRefs.current.forEach((p) => p?.audioEl?.current?.pause?.());
    setPreviewPlayPending(false);
    setPlayPausePlayer("pause");
  }, []);

  // Start once every clip on the page is decoded, so none is cut short.
  useEffect(() => {
    if (!previewPlayPending || !previewReady || !syncPreview) {
      return;
    }

    setPreviewPlayPending(false);
    setPlayPausePlayer("play");
  }, [previewPlayPending, previewReady, syncPreview]);

  // Stop preview at the end of the loaded page so unloaded dialogue audio is never skipped.
  useEffect(() => {
    if (!syncPreview) {
      return;
    }

    const dialogueEndTime = getDialoguePageEndTime(audioData);
    const pageEndTime =
      dialogueEndTime === null
        ? null
        : Math.max(dialogueEndTime, previewTimelineEndTime ?? -Infinity);
    const videoTime = Number(currentTime);

    if (pageEndTime === null || !Number.isFinite(videoTime)) {
      return;
    }

    if (videoTime < pageEndTime) {
      return;
    }

    if (playPausePlayer === "play") {
      requestSyncPause();

      if (
        continuePreviewAcrossPages &&
        Number(pageNumber) < Number(totalPages)
      ) {
        const targetPage = Number(pageNumber) + 1;

        setPendingContinuousPreviewPage(targetPage);
        toast.info("Loading the next dialogue page…");

        nextPrevPageAPI("next").then((pageLoaded) => {
          if (!pageLoaded) {
            setPendingContinuousPreviewPage(null);
          }
        });
        return;
      }

      toast.info(
        Number(pageNumber) >= Number(totalPages)
          ? "Preview paused at the end of the final dialogue page."
          : "Preview paused at the end of the loaded dialogue page. Move to the next page to continue."
      );
    }
  }, [
    audioData,
    continuePreviewAcrossPages,
    currentTime,
    nextPrevPageAPI,
    pageNumber,
    playPausePlayer,
    previewTimelineEndTime,
    requestSyncPause,
    syncPreview,
    totalPages,
  ]);

  // Resume on the next page; play waits for that page's clips to decode.
  useEffect(() => {
    if (
      pendingContinuousPreviewPage === null ||
      !syncPreview ||
      Number(pageNumber) !== Number(pendingContinuousPreviewPage) ||
      pageButtonActivity
    ) {
      return;
    }

    setPendingContinuousPreviewPage(null);
    requestSyncPlay();
  }, [
    pageButtonActivity,
    pageNumber,
    pendingContinuousPreviewPage,
    requestSyncPlay,
    syncPreview,
  ]);

  useEffect(() => {
    if (!continuePreviewAcrossPages || !syncPreview) {
      setPendingContinuousPreviewPage(null);
    }
  }, [continuePreviewAcrossPages, syncPreview]);

  useEffect(() => {
    if (!syncPreview) {
      setPreviewPlayPending(false);
    }
  }, [syncPreview]);

  // Playing a single row pauses the page preview so the two never overlap.
  const handleRowAudioPlay = useCallback(
    (index) => {
      stopAllOtherAudio(index);

      if (syncPreview && playPausePlayer === "play") {
        setPreviewPlayPending(false);
        setPlayPausePlayer("pause");
      }
    },
    [playPausePlayer, stopAllOtherAudio, syncPreview]
  );

  useEffect(() => {
    const translatedPlayers = [...translatedAudioRefs.current];
    const originalPlayers = [...originalAudioRefs.current];

    return () => {
      translatedPlayers.forEach((player) => {
        if (player) {
          player.pause();
        }
      });

      originalPlayers.forEach((player) => {
        if (player && player.audioEl.current) {
          player.audioEl.current.pause();
        }
      });
    };
  }, []);

  const handleSubtitleOnlyChange = async (dialogueId, isSubtitleOnly) => {
    try {
      const updatedData = [...audioData];
      const dialogueIndex = updatedData.findIndex(
        (item) => item.dbid === dialogueId
      );

      if (dialogueIndex === -1) {
        toast.error("Dialogue not found");
        return;
      }

      updatedData[dialogueIndex] = {
        ...updatedData[dialogueIndex],
        subtitleOnly: isSubtitleOnly,
      };

      setAudioData(updatedData);

      setSubtitleOnlyMap({
        ...subtitleOnlyMap,
        [dialogueId]: isSubtitleOnly,
      });

      const response = await qaPost(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[dialogueIndex],
      });

      if (response.data) {
        console.log(`Subtitle only status updated for dialogue ${dialogueId}`);
      }
    } catch (err) {
      console.error("Error updating subtitle status:", err);
      toast.error("Error updating subtitle status");
    }
  };

  const handleVEngineTypeChange = async (dialogueId, engineValue) => {
    try {
      const updatedData = [...audioData];
      const dialogueIndex = updatedData.findIndex(
        (item) => item.dbid === dialogueId
      );

      if (dialogueIndex === -1) {
        toast.error("Dialogue not found");
        return;
      }

      updatedData[dialogueIndex] = {
        ...updatedData[dialogueIndex],
        vEngineType: engineValue,
      };

      setAudioData(updatedData);

      setVEngineTypeMap((prev) => ({
        ...prev,
        [dialogueId]: engineValue,
      }));

      const response = await qaPost(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[dialogueIndex],
      });

      if (response.data) {
        console.log(`Voice engine updated for dialogue ${dialogueId}`);
      }
    } catch (err) {
      console.error("Error updating voice engine:", err);
      toast.error("Error updating voice engine");
    }
  };

  function handleSrtTextChange(e, index) {
    const updatedData = [...audioData];

    updatedData[index].translations = updatedData[index].translations.map(
      (prev) => {
        if (prev.languageCode === languageCode) {
          return {
            ...prev,
            srtText: e.target.value,
          };
        }

        return prev;
      }
    );

    setAudioData(updatedData);
    clearTimeout(timeoutIdRef.current);

    timeoutIdRef.current = setTimeout(async () => {
      await qaPost(UPDATE_ONE_SPEECH, {
        projectId: projectFile.id,
        dialogue: updatedData[index],
      });
    }, 1650);
  }

  const togglePerformanceControls = async (dialogueId, isApproved) => {
    setPerformanceCollapsedMap((prev) => ({
      ...prev,
      [dialogueId]: isApproved,
    }));

    try {
      await qaPost(SET_DIALOGUE_APPROVAL_STATUS, {
        projectId: projectFile.id,
        dialogueId,
        approved: isApproved,
        languageId: languageCode,
      });
    } catch (err) {
      console.error("Error updating approval status:", err);
      toast.error("Error updating approval status");

      setPerformanceCollapsedMap((prev) => ({
        ...prev,
        [dialogueId]: !isApproved,
      }));
    }
  };

  // "" selects the original footage. Versions are matched by uniqueId because
  // two versions can share a name.
  const handleVersionSelect = (uniqueId) => {
    if (!uniqueId) {
      setDubbedVideoReference("");
      setVideoVersion("");
      setVideoUniqueId("");
      return;
    }

    const video = dubbedVideosList.find((item) => item.uniqueId === uniqueId);

    if (!video) {
      return;
    }

    setDubbedVideoReference(video.url);
    setVideoVersion(video.version);
    setVideoUniqueId(video.uniqueId);
  };

  const mediaDownloadItems = useMemo(
    () =>
      buildMediaDownloadItems({
        version: selectedDubbedVideo,
        dubbedAudiosList: dubbedAudiosList ?? projectFile?.dubbedAudiosList,
        videoUrl: projectFile?.videoUrl,
        uploadedAudioTypes: projectFile?.uploadedAudioTypes,
      }),
    [
      selectedDubbedVideo,
      dubbedAudiosList,
      projectFile?.dubbedAudiosList,
      projectFile?.videoUrl,
      projectFile?.uploadedAudioTypes,
    ]
  );

  const triggerDownload = (blobParts, fileName) => {
    const file = new File(blobParts, fileName, {
      type: "text/plain",
    });

    const link = document.createElement("a");
    const url = URL.createObjectURL(file);
    link.href = url;
    link.download = file.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const handleDownloadAttribution = async () => {
    if (!projectFile.characters) {
      toast.error("There are no characters in the project");
      return;
    }

    setAttributionDownloading(true);
    try {
      const languageNames = new Intl.DisplayNames(["en"], {
        type: "language",
      });

      let text = `Localization Cast\n\n${languageNames
        .of(languageCode)
        .toUpperCase()} (AI ASSISTED)\n\n`;
      for (const character of projectFile.characters) {
        text += `${character.displayName.padEnd(20, " ")}`;
        if (character.actorName) {
          text +=
            `${character.actorName.toUpperCase()} (SELF)\n` +
            `                    VARIOUS (${companyName.toUpperCase()})`;
        }

        text += "\n\n";
      }

      triggerDownload([text], "attribution-list.txt");
    } finally {
      setAttributionDownloading(false);
    }
  };

  const handleDownloadSRT = async () => {
    try {
      setSrtDownloadLoading(true);
      setSrtDownloadError(null);

      const response = await axios.post(SRT, {
        projectId: projectFile.id,
        language: languageCode,
      });

      const fileResponse = await axios.get(response.data.url, {
        responseType: "blob",
      });

      const blob = new Blob([fileResponse.data], { type: "text/plain" });
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = response.data.filename;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);

      toast.success("SRT file downloaded successfully");
    } catch (err) {
      setSrtDownloadError(err.message);
      toast.error(
        `Error downloading SRT file ${err.response?.data?.error || ""}`
      );
      console.error("Error downloading SRT:", err);
    } finally {
      setSrtDownloadLoading(false);
    }
  };

  if (!projectFile?.id) {
    return <Loader />;
  }

  return (
    <Grid
      item
      container
      justifyContent="center"
      marginTop={0.5}
      className={pageClasses["Page"]}
    >
      <ToastContainer position="top-center" />
      <Loader Load={audioLoader} />
      <DialogueRowActionDialog
        action={rowAction}
        busy={rowActionBusy}
        onCancel={() => setRowAction(null)}
        onConfirm={handleConfirmRowAction}
        formatTime={formatTime}
        getSpeakerName={findDisplayName}
      />

      <Grid item container xs={12} direction="column" sx={{ px: 1 }}>
        <QASubmitBar
          projectId={projectFile?.id}
          language={languageCode}
          languageName={getLanguageDisplayName(languageCode)}
        />
        <Grid item container direction="row">
          {/* Downloads and versions panel beside the video; the row stays pinned while scrolling. */}
          <Grid
            item
            xs={12}
            container
            direction="row"
            wrap="nowrap"
            gap={1}
            className={qaClasses["QAVideoRow"]}
            // Same fixed background as the page, so dialogues scrolling under
            // the pinned row don't show through its gaps.
            sx={{ ...backgroundWellSx, pb: 1 }}
          >
            {/* As wide as the video at its fixed height, so there's no letterboxing;
                it still shrinks when the screen is narrower. */}
            <Grid
              item
              sx={{
                flex: `0 1 ${Math.round(VIDEO_HEIGHT_PX * videoAspectRatio)}px`,
                minWidth: 0,
                position: "relative",
              }}
            >
              {downloadOnly && <DownloadOnlyNotice />}
              <PerformanceVideoPlayer
                source={videoUrl}
                onPlayWithoutSource={
                  waitingForPlay
                    ? () => setLoadRequestedFor(dubbedVideoReference)
                    : undefined
                }
                onVideoSizeChange={handleVideoSizeChange}
                settingsMenu
                skipSeconds={5}
                dialogueSkip
                subtitles={subtitles}
                showOriginalSubtitles={showOriginalSubtitles}
                showSubtitles={showTranslatedSubtitles}
                toggleOriginalSubtitles={() =>
                  setShowOriginalSubtitles((shown) => !shown)
                }
                toggleTranslatedSubtitles={() =>
                  setShowTranslatedSubtitles((shown) => !shown)
                }
                originalLanguageDisplay={getLanguageDisplayName(
                  projectFile.originalLanguage ||
                    projectFile.orginalLang ||
                    "en"
                )}
                translatedLanguageDisplay={getLanguageDisplayName(languageCode)}
                syncPreview={syncPreview}
                setSyncPreview={setSyncPreview}
                previewVolume={previewVolume}
                onPreviewVolumeChange={setPreviewVolume}
                continuePreviewAcrossPages={continuePreviewAcrossPages}
                setContinuePreviewAcrossPages={setContinuePreviewAcrossPages}
                playPausePlayer={playPausePlayer}
                seekTime={seekTime}
                displayAudioTime={displayAudioTime}
                seekTimeIndex={seekTimeIndex}
                goToPageAccordingTimeAPI={goToPageAccordingTimeAPI}
                onSkip={goToPageIfTimeNotLoaded}
                onVideoElement={setPreviewVideoElement}
                onSyncPlay={requestSyncPlay}
                onSyncPause={requestSyncPause}
              />
            </Grid>

            <section
              className={qaClasses["QASidePanel"]}
              // Takes the width the video doesn't use. Its contents never
              // stretch the row taller than the video; they scroll instead.
              style={{ flex: "1 0 220px", contain: "size" }}
              aria-label={
                {
                  downloads: "Downloads",
                  versions: "Video versions",
                  characters: "Casting",
                }[sidePanelTab]
              }
            >
              <div className={pageClasses["PanelTabs"]} role="tablist">
                {[
                  { value: "characters", label: "Casting" },
                  { value: "versions", label: "Versions" },
                  { value: "downloads", label: "Downloads" },
                ].map((tab) => (
                  <button
                    key={tab.value}
                    type="button"
                    role="tab"
                    aria-selected={sidePanelTab === tab.value}
                    className={`${pageClasses["PanelTab"]} ${
                      sidePanelTab === tab.value
                        ? pageClasses["PanelTabSelected"]
                        : ""
                    }`}
                    onClick={() => setSidePanelTab(tab.value)}
                  >
                    {tab.label}
                    {tab.value === "characters" &&
                      sidePanelTab !== "characters" &&
                      (voiceActivity.generating || voiceActivity.ready) && (
                        <span
                          className={`${pageClasses["PanelTabDot"]} ${
                            voiceActivity.generating
                              ? ""
                              : pageClasses["PanelTabDotReady"]
                          }`}
                          title={
                            voiceActivity.generating
                              ? "Generating voices"
                              : "New takes ready"
                          }
                          aria-label={
                            voiceActivity.generating
                              ? "Generating voices"
                              : "New takes ready"
                          }
                        />
                      )}
                  </button>
                ))}
              </div>

              {sidePanelTab === "downloads" ? (
                <>
                  <ul className={pageClasses["PanelList"]}>
                    <li>
                      <MediaDownloadMenu
                        projectId={projectFile?.id}
                        items={mediaDownloadItems}
                        renderTrigger={(triggerProps) => (
                          <button
                            type="button"
                            className={pageClasses["PanelRow"]}
                            {...triggerProps}
                          >
                            <span
                              className={pageClasses["PanelIcon"]}
                              style={{ background: "#dbeafe", color: "#1e3a8a" }}
                            >
                              <MovieOutlinedIcon sx={{ fontSize: 16 }} />
                            </span>
                            <span className={pageClasses["PanelRowText"]}>
                              <span className={pageClasses["PanelRowTitle"]}>
                                Media files
                              </span>
                              <span className={pageClasses["PanelRowMeta"]}>
                                {selectedDubbedVideo
                                  ? selectedDubbedVideo.version
                                  : "Original"}
                              </span>
                            </span>
                            <ArrowDropDownIcon
                              fontSize="small"
                              className={pageClasses["PanelRowEnd"]}
                            />
                          </button>
                        )}
                      />
                    </li>

                    <li>
                      <button
                        type="button"
                        className={pageClasses["PanelRow"]}
                        onClick={handleDownloadAttribution}
                        disabled={attributionDownLoading}
                      >
                        <span
                          className={pageClasses["PanelIcon"]}
                          style={{ background: "#fef3c7", color: "#78350f" }}
                        >
                          <DescriptionOutlinedIcon sx={{ fontSize: 16 }} />
                        </span>
                        <span className={pageClasses["PanelRowText"]}>
                          <span className={pageClasses["PanelRowTitle"]}>
                            Attribution list
                          </span>
                          <span className={pageClasses["PanelRowMeta"]}>
                            {attributionDownLoading
                              ? "Generating…"
                              : "Credits for this project"}
                          </span>
                        </span>
                        {attributionDownLoading ? (
                          <CircularProgress
                            size={16}
                            className={pageClasses["PanelRowEnd"]}
                          />
                        ) : (
                          <DownloadIcon
                            fontSize="small"
                            className={pageClasses["PanelRowEnd"]}
                          />
                        )}
                      </button>
                    </li>

                    <li>
                      <button
                        type="button"
                        className={pageClasses["PanelRow"]}
                        onClick={handleDownloadSRT}
                        disabled={srtDownloadLoading}
                      >
                        <span
                          className={pageClasses["PanelIcon"]}
                          style={{ background: "#dcfce7", color: "#14532d" }}
                        >
                          <SubtitlesOutlinedIcon sx={{ fontSize: 16 }} />
                        </span>
                        <span className={pageClasses["PanelRowText"]}>
                          <span className={pageClasses["PanelRowTitle"]}>
                            Subtitles (SRT)
                          </span>
                          <span className={pageClasses["PanelRowMeta"]}>
                            {srtDownloadLoading
                              ? "Generating…"
                              : "Translated subtitle file"}
                          </span>
                        </span>
                        {srtDownloadLoading ? (
                          <CircularProgress
                            size={16}
                            className={pageClasses["PanelRowEnd"]}
                          />
                        ) : (
                          <DownloadIcon
                            fontSize="small"
                            className={pageClasses["PanelRowEnd"]}
                          />
                        )}
                      </button>
                    </li>
                  </ul>

                  {srtDownloadError && (
                    <div className={pageClasses["PanelError"]}>
                      Couldn't download the SRT file. Try again.
                    </div>
                  )}
                </>
              ) : sidePanelTab === "versions" ? (
                <>
                  <ul
                    className={pageClasses["PanelList"]}
                    aria-label="Video versions"
                  >
                    {[
                      {
                        uniqueId: "",
                        version: "Original",
                        date: "Original footage",
                      },
                      ...dubbedVideosList.map((video) => ({
                        uniqueId: video.uniqueId,
                        version: video.version,
                        date: `${convertToDate(
                          video.creationDate
                        )} · ${audioLayoutLabel(video)} · ${videoSourceLabel(
                          video
                        )}${isPlayableVersion(video) ? "" : " · Download only"}`,
                      })),
                    ].map((item) => {
                      const isSelected =
                        item.uniqueId === ""
                          ? videoVersion === ""
                          : videoVersion !== "" &&
                            videoUniqueId === item.uniqueId;

                      return (
                        <li key={item.uniqueId || "original"}>
                          <button
                            type="button"
                            aria-pressed={isSelected}
                            className={`${pageClasses["PanelRow"]} ${
                              isSelected ? pageClasses["PanelRowSelected"] : ""
                            }`}
                            onClick={() => handleVersionSelect(item.uniqueId)}
                          >
                            <span
                              className={pageClasses["PanelIcon"]}
                              style={
                                item.uniqueId
                                  ? { background: "#ede9fe", color: "#4c1d95" }
                                  : { background: "#e5e7eb", color: "#374151" }
                              }
                            >
                              {item.uniqueId ? (
                                <VideoLibraryOutlinedIcon sx={{ fontSize: 16 }} />
                              ) : (
                                <MovieOutlinedIcon sx={{ fontSize: 16 }} />
                              )}
                            </span>
                            <span className={pageClasses["PanelRowText"]}>
                              <span
                                className={pageClasses["PanelRowTitle"]}
                                title={item.version}
                              >
                                {item.version}
                              </span>
                              <span className={pageClasses["PanelRowMeta"]}>
                                {item.date}
                              </span>
                            </span>
                            {isSelected && (
                              <CheckIcon
                                fontSize="small"
                                className={pageClasses["PanelRowEnd"]}
                              />
                            )}
                          </button>
                        </li>
                      );
                    })}
                  </ul>

                  {/* Renders a new dubbed version from the current dialogue. */}
                  <form
                    className={pageClasses["CreateVersion"]}
                    onSubmit={(event) => {
                      event.preventDefault();
                      finalSubmission();
                    }}
                  >
                    <label
                      className={pageClasses["CreateVersionLabel"]}
                      htmlFor="create-version-name"
                    >
                      Create a new version
                    </label>
                    <div className={pageClasses["CreateVersionRow"]}>
                      <input
                        id="create-version-name"
                        className={pageClasses["CreateVersionInput"]}
                        type="text"
                        placeholder="Version name"
                        value={versionName}
                        onChange={(e) =>
                          setVersionName(formatInputs(e.target.value))
                        }
                      />
                      <button
                        type="submit"
                        className={pageClasses["CreateVersionButton"]}
                        disabled={isCreatingVersion}
                      >
                        {isCreatingVersion ? (
                          <CircularProgress size={14} color="inherit" />
                        ) : (
                          "Create"
                        )}
                      </button>
                    </div>
                    <ExportOptions className={pageClasses["CreateVersionOptions"]}>
                      <ExportVideoSourceSelect
                        id="create-version-video"
                        value={videoSource}
                        onChange={setVideoSource}
                        hasSourceVideo={hasSourceVideo}
                        disabled={isCreatingVersion}
                      />
                      <ExportLayoutSelect
                        id="create-version-layout"
                        value={outputAudioLayout}
                        onChange={setOutputAudioLayout}
                        disabled={isCreatingVersion}
                      />
                    </ExportOptions>
                  </form>
                </>
              ) : null}

              {/* Stays mounted while another section is showing, so a voice
                  form, its takes and a generation in progress survive
                  switching sections. */}
              <div
                className={pageClasses["PanelPane"]}
                hidden={sidePanelTab !== "characters"}
              >
                <CharacterVoicePanel
                  projectId={projectFile.id}
                  projectName={projectFile.name}
                  characters={characters}
                  isLoading={!charactersLoaded}
                  onVoiceAccepted={reloadCharacters}
                  onCharactersImported={reloadCharacters}
                  onCharacterCreated={reloadCharacters}
                  onCharacterDeleted={reloadCharacters}
                  onActivityChange={setVoiceActivity}
                  isVisible={sidePanelTab === "characters"}
                  languageCode={languageCode}
                  // Show the new takes if that character is on this page.
                  onLinesRegenerated={(speaker) => {
                    if (audioData.some((line) => line.speaker === speaker)) {
                      goToPageAPI(pageNumber);
                    }
                  }}
                  onCharacterRenamed={(speaker, displayName) =>
                    setCharacters((previous) =>
                      previous.map((character) =>
                        character.speaker === speaker
                          ? { ...character, displayName }
                          : character
                      )
                    )
                  }
                />
              </div>
            </section>
          </Grid>

          {/* The dialogue sections stay mounted while the sounds show, so
              filters, paging and scroll position survive switching back. */}
          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
              mt: 0.5,
              mb: 1,
            }}
          >
            {/* As wide as the video column above. Always rendered, so Filters
                stays on the right even while the bar has no counts to show. */}
            <Box
              sx={{
                flex: `0 1 ${Math.round(VIDEO_HEIGHT_PX * videoAspectRatio)}px`,
                minWidth: 0,
                display: "flex",
                visibility: workSection === "dialogue" ? "visible" : "hidden",
              }}
            >
              <DialogueAttentionProgress
                projectId={projectFile?.id}
                languageCode={languageCode}
                refreshKey={audioData}
                onSelect={(filters) =>
                  handleDialogueSearch({
                    ...DEFAULT_DIALOGUE_SEARCH_FILTERS,
                    ...filters,
                  })
                }
                disabled={loader || pageButtonActivity}
              />
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <WorkSectionSwitch
                value={workSection}
                onChange={setWorkSection}
                soundCount={nonverbalInDub}
              />
              <Box sx={{ display: workSection === "dialogue" ? "flex" : "none" }}>
                <DialogueFilterBar
                  compact
                  value={dialogueSearchFilters}
                  onChange={handleDialogueSearch}
                  onClear={handleClearDialogueSearch}
                  characters={characters}
                  getSpeakerDisplayName={findDisplayName}
                  emotionOptions={originalAudioEmotionOptions}
                  attentionOptions={DIALOGUE_ATTENTION_OPTIONS}
                  showNoteFilter
                  showClosedFilter
                  showRowFlagFilters
                  resultCount={isDialogueSearchActive ? searchResultCount : null}
                  totalCount={numberOfDialogues}
                  disabled={loader || pageButtonActivity}
                />
              </Box>
            </Box>
          </Grid>

          {workSection === "nonverbal" ? (
            <Grid item xs={12}>
              <NonverbalSoundsSection
                regions={nonverbal.regions}
                loading={nonverbal.loading}
                busyId={nonverbal.busyId}
                onReview={nonverbal.review}
                onSeek={(start) => {
                  setSeekTime(start);
                  setSeekTimeIndex((prev) => prev + 1);
                }}
              />
            </Grid>
          ) : null}

          <Grid
            item
            container
            xs={12}
            sx={{ display: workSection === "dialogue" ? undefined : "none" }}
          >
            <Grid
              item
              container
              className={classes["AudioWorkPlace"]}
              direction="column"
            >
              <div className={classes["AudioWorkTableWrapper"]}>
                <table className={classes["AudioWorkTable"]}>
                  <thead>
                    <tr className={classes["AudioWorkTableHeadRow"]}>
                      <th
                        className={`${classes["AudioWorkTableHeaderSpacer"]} ${classes["AudioWorkTableColumnCharacter"]}`}
                      >
                        Character
                      </th>
                      <th
                        className={`${classes["AudioWorkTableHeaderCell"]} ${classes["AudioWorkTableColumnOriginal"]}`}
                      >
                        Original
                      </th>
                      <th
                        className={`${classes["AudioWorkTableHeaderCell"]} ${classes["AudioWorkTableColumnTranslation"]}`}
                      >
                        Translation
                      </th>
                      <th
                        className={`${classes["AudioWorkTableHeaderCell"]} ${classes["AudioWorkTableColumnNewAudio"]}`}
                      >
                        Performance Direct
                      </th>
                      <th
                        className={`${classes["AudioWorkTableHeaderCell"]} ${classes["AudioWorkTableColumnSrt"]}`}
                      >
                        SRT
                      </th>
                      <th
                        className={`${classes["AudioWorkTableHeaderCell"]} ${classes["AudioWorkTableColumnNotes"]}`}
                      >
                        Notes &amp; Rating
                      </th>
                    </tr>
                  </thead>

                  <tbody
                    className={classes["AudioWorkPlaceChatBoxScroller"]}
                    ref={containerRef}
                  >
                    {loader ? (
                      <DialogueTableSkeletonRows rowCount={itemsPerPage} />
                    ) : audioData ? (
                      <>
                        {audioData.map((data, index) => {
                          const translation = findTransObjectsbyLangCode(
                            data?.translations
                          );

                          const translationDuration =
                            translation?.translatedAudioDuration ??
                            data?.translatedAudioDurationTemp;

                          const durationNote = checkTranslationLength(
                            data.end - data.start,
                            translationDuration
                          );

                          const recommendedSpeedOption =
                            getRecommendedSpeedOption(
                              data.end - data.start,
                              translationDuration
                            );

                          const overlapDuration = translation?.translatedAudio
                            ? translation?.translatedAudioDuration
                            : null;

                          const translationText =
                            translation?.translatedText || "";

                          const srtText = translation?.srtText;

                          const translationNote =
                            translation?.translatedAudioNote ?? "";

                          const translationRating =
                            translation?.translatedAudioRating ?? 0;

                          const srtDisplayText =
                            srtText === undefined ||
                            srtText === null ||
                            srtText === ""
                              ? translationText
                              : srtText;

                          const isPerformanceCollapsed =
                            performanceCollapsedMap[data.dbid] ?? false;

                          const storedVoiceEngine =
                            vEngineTypeMap[data.dbid] || DEFAULT_VOICE_ENGINE;

                          const selectedVoiceEngine =
                            getSupportedVoiceEngine(storedVoiceEngine);

                          const isLegacyEngine =
                            isLegacyVoiceEngine(storedVoiceEngine);

                          const hasUnsupportedVoiceEngine =
                            !isSupportedVoiceEngine(storedVoiceEngine);

                          const isSoundEffectEngine =
                            selectedVoiceEngine === SOUND_EFFECT_VOICE_ENGINE;

                          return (
                            <tr
                              key={data.dbid || index}
                              data-dialogue-id={data.dbid}
                              className={`${classes["AudioWorkTableRow"]} ${
                                data.dbid &&
                                data.dbid === highlightedDialogueId
                                  ? rowActionClasses.NewRow
                                  : ""
                              }`}
                            >
                              <td
                                className={`${classes["AudioWorkMetaColumn"]} ${classes["AudioWorkTableColumnCharacter"]}`}
                              >
                                <Grid
                                  container
                                  direction="column"
                                  gap={1.5}
                                  alignItems="stretch"
                                >
                                  <Grid
                                    item
                                    container
                                    justifyContent="center"
                                    height="25px"
                                  >
                                    {data.speaker ? (
                                      <Grid>
                                        <Select
                                          value={data.speaker}
                                          onChange={(e) =>
                                            handleSpeakerChange(e, data.id)
                                          }
                                          input={<BootstrapInputForAvalialbe />}
                                        >
                                          {characters?.map(
                                            (char, charIndex) => (
                                              <MenuItem
                                                key={charIndex}
                                                value={char.speaker}
                                                className={
                                                  classes[
                                                    "DialogueRowCharacterOption"
                                                  ]
                                                }
                                              >
                                                <span>
                                                  {findDisplayName(
                                                    char.speaker
                                                  )}
                                                </span>

                                                {!!char.projectId && (
                                                  <span
                                                    title="Imported Character"
                                                    className={
                                                      classes[
                                                        "DialogueRowImportedCharacterIndicator"
                                                      ]
                                                    }
                                                  >
                                                    ↙️
                                                  </span>
                                                )}
                                              </MenuItem>
                                            )
                                          )}
                                        </Select>
                                      </Grid>
                                    ) : (
                                      <Grid marginBottom={1}>
                                        <Select
                                          value={data.speaker}
                                          onChange={(e) =>
                                            handleSpeakerChange(e, data.id)
                                          }
                                          input={<BootstrapInput />}
                                        >
                                          {characters?.map((char) => (
                                            <MenuItem
                                              key={char.speaker}
                                              value={char.speaker}
                                              className={
                                                classes[
                                                  "DialogueRowCharacterSimpleOption"
                                                ]
                                              }
                                            >
                                              {findDisplayName(char.speaker)}
                                            </MenuItem>
                                          ))}
                                        </Select>
                                      </Grid>
                                    )}
                                  </Grid>

                                  <Grid item>
                                    <InputMask
                                      mask="99:99:99.99"
                                      value={inputStartTime[index] || ""}
                                      onChange={(e) =>
                                        handleStartTimeChange(e, index)
                                      }
                                      className={`${classes["AudioWorkPlaceTimelineEditTranslation"]} ${classes["DialogueRowTimelineField"]}`}
                                      placeholder="HH:MM:SS.MS"
                                    >
                                      {(inputProps) => (
                                        <InputBase
                                          {...inputProps}
                                          fullWidth
                                          className={
                                            classes["DialogueRowTimelineInput"]
                                          }
                                        />
                                      )}
                                    </InputMask>
                                  </Grid>

                                  <Grid item>
                                    <InputMask
                                      mask="99:99:99.99"
                                      value={inputEndTime[index] || ""}
                                      onChange={(e) =>
                                        handleEndTimeChange(e, index)
                                      }
                                      className={`${classes["AudioWorkPlaceTimelineEditTranslation"]} ${classes["DialogueRowTimelineField"]}`}
                                      placeholder="HH:MM:SS.MS"
                                    >
                                      {(inputProps) => (
                                        <InputBase
                                          {...inputProps}
                                          fullWidth
                                          className={
                                            classes["DialogueRowTimelineInput"]
                                          }
                                        />
                                      )}
                                    </InputMask>
                                  </Grid>

                                  <Grid item container justifyContent="center">
                                    <DialogueRowActions
                                      canMerge={
                                        index > 0 && !isDialogueSearchActive
                                      }
                                      mergeDisabledReason={
                                        isDialogueSearchActive
                                          ? "Clear the filters to merge dialogues"
                                          : Number(pageNumber) > 1
                                          ? "The dialogue above is on the previous page"
                                          : "No dialogue above to merge with"
                                      }
                                      disabled={rowActionBusy || !data.dbid}
                                      canAdd={!isDialogueSearchActive}
                                      onAdd={() =>
                                        handleAddDialogueBelow(index)
                                      }
                                      onMerge={() => openMergeDialog(index)}
                                      onDelete={() => openDeleteDialog(index)}
                                    />
                                  </Grid>
                                </Grid>
                              </td>

                              <td
                                className={`${classes["AudioWorkDataColumn"]} ${classes["AudioWorkTableColumnOriginal"]}`}
                              >
                                <Grid container direction="column">
                                  <Grid item>
                                    <Grid
                                      item
                                      className={
                                        classes["DialogueRowHeaderLine"]
                                      }
                                    >
                                      <FormControlLabel
                                        className={
                                          classes["DialogueRowSwitchControl"]
                                        }
                                        control={
                                          <RowFlagSwitch
                                            checked={!!data.keepOriginalText}
                                            onChange={() =>
                                              handleKeepOriginalText(data.id)
                                            }
                                          />
                                        }
                                        label="Use original"
                                      />
                                    </Grid>

                                    <div
                                      className={
                                        classes["DialogueRowAudioSection"]
                                      }
                                      style={{ width: "98%" }}
                                    >
                                      <NativeClipAudioPlayer
                                        ref={(el) =>
                                          (originalAudioRefs.current[index] = el)
                                        }
                                        src={data.originalAudio}
                                        timeDecimalPlaces={3}
                                        // HTML audio cannot exceed 1, so boosts only apply to translated clips.
                                        volume={
                                          syncPreview
                                            ? Math.min(previewVolume, 1)
                                            : 1
                                        }
                                        onPlay={() => handleRowAudioPlay(index)}
                                      />
                                    </div>
                                  </Grid>

                                  <Grid item>
                                    <textarea
                                      className={`${
                                        classes["AudioWorkTextEditInput"]
                                      } ${classes["DialogueRowJoinedTextArea"]} ${
                                        currentTime >= data.start &&
                                        currentTime < data.end
                                          ? classes["DialogueRowActiveText"]
                                          : ""
                                      }`}
                                      value={data.text}
                                      type="text"
                                      onFocus={() =>
                                        handleTextFocus(index, data.start)
                                      }
                                      onMouseDown={handleTextMouseDown}
                                      onClick={() =>
                                        handleTextClick(index, data.start)
                                      }
                                      onChange={(e) =>
                                        handleTextChange(e, data.id)
                                      }
                                    ></textarea>
                                  </Grid>
                                </Grid>
                              </td>

                              <td
                                className={`${classes["AudioWorkDataColumn"]} ${classes["AudioWorkTableColumnTranslation"]}`}
                              >
                                <Grid container direction="row">
                                  {data.keepOriginalText ? (
                                    <></>
                                  ) : (
                                    <>
                                      <Grid item container direction="column">
                                        <Grid
                                          item
                                          fontSize="var(--font-size-normal)"
                                          color="green"
                                          className={`${
                                            classes["DialogueRowHeaderLine"]
                                          } ${
                                            classes["DialogueRowStatusTags"]
                                          }`}
                                        >
                                          {durationNote ? (
                                            <span
                                              className={`${
                                                classes["DialogueRowStatusTag"]
                                              } ${
                                                durationNote.label === "Perfect"
                                                  ? classes[
                                                      "DialogueRowStatusTagSuccess"
                                                    ]
                                                  : ""
                                              }`}
                                            >
                                              {durationNote.label}
                                            </span>
                                          ) : null}
                                          {handleVoiceOverLapping(
                                            data.id,
                                            overlapDuration
                                          )}
                                        </Grid>

                                        <Grid
                                          item
                                          container
                                          direction="row"
                                          alignItems="center"
                                          width="98%"
                                          className={`${
                                            classes[
                                              "DialogueRowTranslatedPlayerRow"
                                            ]
                                          } ${
                                            classes["DialogueRowAudioSection"]
                                          }`}
                                        >
                                          <Grid item height="100%">
                                            <VolumeSelector
                                              className={
                                                classes[
                                                  "DialogueRowCompactVolume"
                                                ]
                                              }
                                              value={
                                                translation?.translatedAudioVolume ??
                                                null
                                              }
                                              onChange={(e) => {
                                                handleTranslatedAudioVolume(
                                                  e,
                                                  data.id
                                                );
                                              }}
                                            />
                                          </Grid>

                                          <Grid item xs height="100%">
                                            <ClipAudioPlayer
                                              compact
                                              embedded
                                              ref={(el) =>
                                                (translatedAudioRefs.current[
                                                  index
                                                ] = el)
                                              }
                                              src={translation?.translatedAudio}
                                              autoPlayRequest={
                                                audioAutoPlayRequestMap[
                                                  data.dbid
                                                ]
                                              }
                                              decible={
                                                translation?.translatedAudioVolume ??
                                                null
                                              }
                                              playbackVolume={
                                                syncPreview ? previewVolume : 1
                                              }
                                              showScrubBar={false}
                                              timeDecimalPlaces={3}
                                              onPlay={() =>
                                                handleRowAudioPlay(index)
                                              }
                                            />
                                          </Grid>
                                        </Grid>

                                        <Grid item>
                                          <textarea
                                            className={`${
                                              classes["AudioWorkTextEditInput"]
                                            } ${
                                              classes["DialogueRowJoinedTextArea"]
                                            } ${
                                              currentTime >= data.start &&
                                              currentTime < data.end
                                                ? classes[
                                                    "DialogueRowActiveText"
                                                  ]
                                                : ""
                                            }`}
                                            value={translationText}
                                            type="text"
                                            onFocus={() =>
                                              handleTextFocus(index, data.start)
                                            }
                                            onMouseDown={handleTextMouseDown}
                                            onClick={() =>
                                              handleTextClick(index, data.start)
                                            }
                                            onChange={(e) =>
                                              handleTranslationChange(
                                                e,
                                                data.id
                                              )
                                            }
                                          ></textarea>
                                        </Grid>
                                      </Grid>
                                    </>
                                  )}
                                </Grid>
                              </td>

                              <td
                                className={`${classes["AudioWorkDataColumn"]} ${classes["AudioWorkTableColumnNewAudio"]}`}
                              >
                                <Grid container direction="column">
                                  {isPerformanceCollapsed ? (
                                    <Grid
                                      item
                                      container
                                      justifyContent="center"
                                    >
                                      <TaskButton
                                        onClick={() =>
                                          togglePerformanceControls(
                                            data.dbid,
                                            false
                                          )
                                        }
                                        width={performanceToggleButtonWidth}
                                      >
                                        Reopen
                                      </TaskButton>
                                    </Grid>
                                  ) : (
                                    <>
                                      <Grid
                                        item
                                        className={
                                          classes["DialogueRowHeaderLine"]
                                        }
                                      >
                                        <FormControlLabel
                                          className={
                                            classes["DialogueRowSwitchControl"]
                                          }
                                          control={
                                            <RowFlagSwitch
                                              checked={
                                                subtitleOnlyMap[data.dbid] ===
                                                true
                                              }
                                              onChange={(e) =>
                                                handleSubtitleOnlyChange(
                                                  data.dbid,
                                                  e.target.checked
                                                )
                                              }
                                            />
                                          }
                                          label="Subtitle only"
                                        />
                                      </Grid>

                                      <Grid
                                        item
                                        container
                                        justifyContent="flex-start"
                                        alignItems="center"
                                        alignContent="center"
                                        direction="row"
                                        gap={0.6}
                                      >
                                        {!isSoundEffectEngine && (
                                          <Grid
                                            item
                                            fontSize="var(--font-size-normal)"
                                            className={
                                              classes[
                                                "DialogueRowEmotionSelectorWrapper"
                                              ]
                                            }
                                          >
                                            {(() => {
                                              // One selector per line, even if the project repeats a key.
                                              const char = getLineCharacter(
                                                characters,
                                                data.speaker
                                              );
                                              return char ? (
                                                    <select
                                                      value={
                                                        data.tempTransEmotion
                                                      }
                                                      onChange={(e) => {
                                                        const updatedData = [
                                                          ...audioData,
                                                        ];

                                                        updatedData[data.id] = {
                                                          ...updatedData[
                                                            data.id
                                                          ],
                                                          tempTransEmotion:
                                                            e.target.value,
                                                        };

                                                        setAudioData(
                                                          updatedData
                                                        );
                                                      }}
                                                      disabled={
                                                        data.keepOriginalText ||
                                                        subtitleOnlyMap[
                                                          data.dbid
                                                        ] === true
                                                      }
                                                      className={`${
                                                        classes[
                                                          "AudioWorkSelector"
                                                        ]
                                                      } ${
                                                        data.keepOriginalText ||
                                                        subtitleOnlyMap[
                                                          data.dbid
                                                        ] === true
                                                          ? classes[
                                                              "DialogueRowSelectDisabled"
                                                            ]
                                                          : ""
                                                      }`}
                                                    >
                                                      <option value="">
                                                        select emotion
                                                      </option>

                                                      {(() => {
                                                        const options = (
                                                          char.voices ?? []
                                                        ).map((voice) => ({
                                                          label: voice.emotion,
                                                          value: voice.voice_id,
                                                        }));

                                                        return options.map(
                                                          (opt, optIndex) => (
                                                            <option
                                                              value={opt.value}
                                                              key={optIndex}
                                                            >
                                                              {opt.label}
                                                            </option>
                                                          )
                                                        );
                                                      })()}
                                                    </select>
                                              ) : null;
                                            })()}
                                          </Grid>
                                        )}

                                        <Grid item xs={1.5}>
                                          <Grid
                                            item
                                            className={`${
                                              classes["DialogueRowActionIcon"]
                                            } ${
                                              data.keepOriginalText ||
                                              subtitleOnlyMap[data.dbid] ===
                                                true
                                                ? classes[
                                                    "DialogueRowActionIconDisabled"
                                                  ]
                                                : ""
                                            }`}
                                          >
                                            {data.loader &&
                                            data.loaderAction === "single" ? (
                                              <ClipLoader
                                                color={secondaryColor}
                                                loading
                                                size={20}
                                              />
                                            ) : (
                                            <Badge badgeContent={1}>
                                              <AddCircleIcon
                                                disabled={
                                                  audioLoader ||
                                                  data.keepOriginalText ||
                                                  subtitleOnlyMap[data.dbid] ===
                                                    true
                                                }
                                                onClick={() => {
                                                  if (
                                                    data.keepOriginalText ||
                                                    subtitleOnlyMap[
                                                      data.dbid
                                                    ] === true
                                                  ) {
                                                    return;
                                                  }

                                                  if (
                                                    !isSoundEffectEngine &&
                                                    audioData[data.id]
                                                      .tempTransEmotion === ""
                                                  ) {
                                                    toast.error(
                                                      "Error !! Choose an emotion"
                                                    );
                                                    return;
                                                  }

                                                  translatedAudioRefs.current[
                                                    index
                                                  ]?.unlock?.();

                                                  setAudioData((prevData) => {
                                                    const updatedData = [
                                                      ...prevData,
                                                    ];
                                                    updatedData[
                                                      data.id
                                                    ].loader = true;
                                                    updatedData[
                                                      data.id
                                                    ].loaderAction = "single";
                                                    return updatedData;
                                                  });

                                                  handleNewAudioUrl(data.id);
                                                }}
                                                className={
                                                  classes["DialogueRowAddIcon"]
                                                }
                                              />
                                            </Badge>
                                            )}
                                          </Grid>
                                        </Grid>

                                        {!isSoundEffectEngine && (
                                          <Grid item xs={1.5}>
                                            <Grid
                                              item
                                              className={`${
                                                classes["DialogueRowActionIcon"]
                                              } ${
                                                data.keepOriginalText ||
                                                subtitleOnlyMap[data.dbid] ===
                                                  true
                                                  ? classes[
                                                      "DialogueRowActionIconDisabled"
                                                    ]
                                                  : ""
                                              }`}
                                            >
                                              {data.loader &&
                                              data.loaderAction ===
                                                "multiple" ? (
                                                <ClipLoader
                                                  color={secondaryColor}
                                                  loading
                                                  size={20}
                                                />
                                              ) : (
                                              <Badge badgeContent={3}>
                                                <AddCircleIcon
                                                  disabled={
                                                    audioLoader ||
                                                    data.keepOriginalText ||
                                                    subtitleOnlyMap[
                                                      data.dbid
                                                    ] === true
                                                  }
                                                  onClick={() => {
                                                    if (
                                                      data.keepOriginalText ||
                                                      subtitleOnlyMap[
                                                        data.dbid
                                                      ] === true
                                                    ) {
                                                      return;
                                                    }

                                                    if (
                                                      audioData[data.id]
                                                        .tempTransEmotion === ""
                                                    ) {
                                                      toast.error(
                                                        "Error !! Choose an emotion"
                                                      );
                                                      return;
                                                    }

                                                    setAudioData((prevData) => {
                                                      const updatedData = [
                                                        ...prevData,
                                                      ];
                                                      updatedData[
                                                        data.id
                                                      ].loader = true;
                                                      updatedData[
                                                        data.id
                                                      ].loaderAction =
                                                        "multiple";
                                                      return updatedData;
                                                    });

                                                    handleMultipleAudio(
                                                      data.id
                                                    );
                                                  }}
                                                  className={
                                                    classes[
                                                      "DialogueRowAddIcon"
                                                    ]
                                                  }
                                                />
                                              </Badge>
                                              )}
                                            </Grid>
                                          </Grid>
                                        )}
                                      </Grid>

                                      <Grid
                                        item
                                        container
                                        marginTop={0.6}
                                        justifyContent="flex-start"
                                        alignItems="center"
                                        alignContent="center"
                                        direction="row"
                                        gap={0.6}
                                      >
                                        <Grid
                                          item
                                          fontSize="var(--font-size-normal)"
                                        >
                                          <React.Fragment key={index}>
                                            <select
                                              className={`${
                                                classes["AudioWorkSelector"]
                                              } ${
                                                data.keepOriginalText ||
                                                subtitleOnlyMap[data.dbid] ===
                                                  true
                                                  ? classes[
                                                      "DialogueRowSelectDisabled"
                                                    ]
                                                  : ""
                                              }`}
                                              value={
                                                getSelectedGeneratedAudioValue(
                                                  translation
                                                )
                                              }
                                              onChange={(e) => {
                                                selectAudioOption(
                                                  e,
                                                  data.id,
                                                  index
                                                );
                                              }}
                                              disabled={
                                                data.keepOriginalText ||
                                                subtitleOnlyMap[data.dbid] ===
                                                  true
                                              }
                                            >
                                              <option value="">
                                                select options
                                              </option>

                                              {data.tempAudioList.map(
                                                (audio, audioIndex) => {
                                                  const emotionLabel =
                                                    audio.emotion ===
                                                      undefined ||
                                                    audio.emotion === null ||
                                                    audio.emotion === ""
                                                      ? ""
                                                      : `${audio.emotion} `;

                                                  return (
                                                    <option
                                                      value={getGeneratedAudioOptionValue(
                                                        audio
                                                      )}
                                                      key={audioIndex}
                                                    >
                                                      {`${audioIndex} - ${emotionLabel}(${audio.length})`}
                                                    </option>
                                                  );
                                                }
                                              )}
                                            </select>
                                          </React.Fragment>
                                        </Grid>

                                        <Grid item>
                                          <Select
                                            size="small"
                                            value={
                                              speedSelectionMap[data.dbid] ?? ""
                                            }
                                            displayEmpty
                                            onChange={(e) => {
                                              const newSpeed = e.target.value;

                                              setSpeedSelectionMap((prev) => ({
                                                ...prev,
                                                [data.dbid]: newSpeed,
                                              }));

                                              handleAdjustSpeed(data, newSpeed);
                                            }}
                                            disabled={
                                              data.keepOriginalText ||
                                              subtitleOnlyMap[data.dbid] ===
                                                true ||
                                              !translation?.translatedAudio
                                            }
                                            sx={{
                                              // Matches the Close button below it.
                                              width:
                                                performanceToggleButtonWidth,
                                              height: "30px",
                                              fontSize: "14px",
                                              // Tighten MUI's default arrow gutter
                                              // so labels like "Faster 20%" fit.
                                              "&& .MuiSelect-select": {
                                                paddingLeft: "8px",
                                                paddingRight: "20px",
                                              },
                                              "& .MuiSelect-icon": {
                                                right: 0,
                                              },
                                            }}
                                          >
                                            <MenuItem value="" disabled>
                                              Speed
                                            </MenuItem>
                                            <MenuItem value="auto">
                                              Auto
                                            </MenuItem>
                                            <MenuItem
                                              value={1.0}
                                              sx={{
                                                fontWeight:
                                                  recommendedSpeedOption === 1.0
                                                    ? 700
                                                    : 400,
                                              }}
                                            >
                                              Original
                                            </MenuItem>
                                            <MenuItem
                                              value={0.8}
                                              sx={{
                                                fontWeight:
                                                  recommendedSpeedOption === 0.8
                                                    ? 700
                                                    : 400,
                                              }}
                                            >
                                              Slower 20%
                                            </MenuItem>
                                            <MenuItem
                                              value={0.9}
                                              sx={{
                                                fontWeight:
                                                  recommendedSpeedOption === 0.9
                                                    ? 700
                                                    : 400,
                                              }}
                                            >
                                              Slower 10%
                                            </MenuItem>
                                            <MenuItem
                                              value={1.1}
                                              sx={{
                                                fontWeight:
                                                  recommendedSpeedOption === 1.1
                                                    ? 700
                                                    : 400,
                                              }}
                                            >
                                              Faster 10%
                                            </MenuItem>
                                            <MenuItem
                                              value={1.2}
                                              sx={{
                                                fontWeight:
                                                  recommendedSpeedOption === 1.2
                                                    ? 700
                                                    : 400,
                                              }}
                                            >
                                              Faster 20%
                                            </MenuItem>
                                          </Select>
                                        </Grid>

                                        <Grid item>
                                          <FormControl
                                            size="small"
                                            disabled={
                                              data.keepOriginalText ||
                                              subtitleOnlyMap[data.dbid] ===
                                                true
                                            }
                                            className={
                                              classes[
                                                "DialogueRowVoiceEngineControl"
                                              ]
                                            }
                                          >
                                            <InputLabel
                                              id={`voice-engine-label-${data.id}`}
                                            >
                                              Voice Engine
                                            </InputLabel>

                                            <Select
                                              labelId={`voice-engine-label-${data.id}`}
                                              value={
                                                hasUnsupportedVoiceEngine
                                                  ? storedVoiceEngine
                                                  : selectedVoiceEngine
                                              }
                                              label="Voice Engine"
                                              onChange={(e) =>
                                                handleVEngineTypeChange(
                                                  data.dbid,
                                                  e.target.value
                                                )
                                              }
                                            >
                                              {hasUnsupportedVoiceEngine && (
                                                <MenuItem
                                                  value={storedVoiceEngine}
                                                  disabled
                                                >
                                                  {LEGACY_AUDIO_ENGINE_LABEL}
                                                </MenuItem>
                                              )}
                                              {VOICE_ENGINE_OPTIONS.map(
                                                (option) => (
                                                  <MenuItem
                                                    key={option.value}
                                                    value={option.value}
                                                  >
                                                    {option.label}
                                                  </MenuItem>
                                                )
                                              )}
                                            </Select>
                                          </FormControl>
                                          {hasUnsupportedVoiceEngine && (
                                            <div
                                              style={{
                                                color:
                                                  "var(--color-error, #d32f2f)",
                                                fontSize:
                                                  "var(--font-size-small)",
                                                marginTop: 4,
                                              }}
                                            >
                                              {isLegacyEngine
                                                ? `${LEGACY_AUDIO_ENGINE_LABEL} audio remains playable, but generation with this legacy engine is blocked. Select a supported engine to create new audio.`
                                                : `Unsupported legacy engine "${storedVoiceEngine}" will use the default engine when generating.`}
                                            </div>
                                          )}
                                        </Grid>

                                        <Grid item>
                                          <TaskButton
                                            onClick={() =>
                                              togglePerformanceControls(
                                                data.dbid,
                                                true
                                              )
                                            }
                                            width={performanceToggleButtonWidth}
                                            height="30px"
                                            style={{ fontSize: "14px" }}
                                            disabled={
                                              !translation?.translatedAudio
                                            }
                                          >
                                            Close
                                          </TaskButton>
                                        </Grid>
                                      </Grid>
                                    </>
                                  )}
                                </Grid>
                              </td>

                              <td className={classes["AudioWorkDataColumn"]}>
                                <Grid
                                  container
                                  direction="column"
                                  alignItems="stretch"
                                >
                                  {data.keepOriginalText ? (
                                    <></>
                                  ) : (
                                    <Grid
                                      item
                                      className={
                                        classes["DialogueRowTextBoxOffset"]
                                      }
                                    >
                                      <textarea
                                        className={`${
                                          classes["AudioWorkTextEditInput"]
                                        } ${
                                          currentTime >= data.start &&
                                          currentTime < data.end
                                            ? classes["DialogueRowActiveText"]
                                            : ""
                                        } ${
                                          classes["DialogueRowSrtTextInput"]
                                        }`}
                                        value={srtDisplayText}
                                        rows={5}
                                        type="text"
                                        placeholder="SRT subtitle text"
                                        onChange={(e) =>
                                          handleSrtTextChange(e, data.id)
                                        }
                                      ></textarea>
                                    </Grid>
                                  )}
                                </Grid>
                              </td>

                              <td className={classes["AudioWorkDataColumn"]}>
                                <Grid
                                  container
                                  direction="column"
                                  justifyContent="flex-start"
                                  alignItems="stretch"
                                >
                                  <Grid
                                    item
                                    className={
                                      classes["DialogueRowNotesRatingRow"]
                                    }
                                  >
                                    <Rating
                                      size="small"
                                      className={classes["DialogueRowRating"]}
                                      value={translationRating}
                                      precision={1}
                                      onChange={(event, newValue) => {
                                        handleDialogueRating(newValue, data.id);
                                      }}
                                    />
                                  </Grid>

                                  <Grid item width="100%">
                                    <textarea
                                      className={
                                        classes["AudioWorkNoteEditInput"]
                                      }
                                      value={translationNote}
                                      placeholder="add note here"
                                      type="text"
                                      onChange={(e) =>
                                        handleNoteChange(e, data.id)
                                      }
                                    ></textarea>
                                  </Grid>
                                </Grid>
                              </td>
                            </tr>
                          );
                        })}
                      </>
                    ) : (
                      <></>
                    )}
                  </tbody>
                </table>
              </div>
            </Grid>

            <Grid
              item
              container
              alignItems="center"
              justifyContent="center"
              marginTop={2}
            >
              <Grid
                item
                container
                alignItems="center"
                justifyContent="center"
                gap={2}
              >
                <Grid item>
                  <TaskButton
                    onClick={() => nextPrevPageAPI("previous")}
                    width="80px"
                    disabled={Number(pageNumber) === 1 || pageButtonActivity}
                  >
                    Previous
                  </TaskButton>
                </Grid>

                <Grid item>
                  <span>
                    Page {pageNumber} of {totalPages}
                  </span>
                </Grid>

                <Grid item>
                  <TaskButton
                    width="80px"
                    onClick={() => nextPrevPageAPI("next")}
                    disabled={
                      Number(pageNumber) === totalPages || pageButtonActivity
                    }
                  >
                    Next
                  </TaskButton>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              item
              container
              alignItems="center"
              justifyContent="center"
              gap={4}
              marginTop={1}
              marginLeft={15.5}
            >
              <Grid item>
                <input
                  type="text"
                  style={{ width: "50px", textAlign: "center" }}
                  value={goToPageNumber}
                  onChange={(e) => {
                    setGoToPageNumber(e.target.value >= 1 ? e.target.value : 1);
                  }}
                />
              </Grid>

              <Grid item>
                <TaskButton
                  onClick={() => goToPageAPI(goToPageNumber)}
                  width="80px"
                >
                  Go
                </TaskButton>
              </Grid>
            </Grid>
          </Grid>

        </Grid>
      </Grid>
    </Grid>
  );
};

export default VideoPerformanceDirectionVersions;
